import React from 'react';
import { toClass } from '../../lib/utils';
import clsx from 'clsx';
import styles from '../../styles/components/atoms/Icon.module.scss';

interface IconProps {
  className?: string;
  name: string;
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | undefined;
  options?: {
    [key: string]: boolean | string | undefined | null;
  };
}

const iconSVG = (name: string) => {
  switch (name) {
    case 'arrow-l':
      return (
        <svg viewBox="0 0 48 48">
          <path
            transform="rotate(180 24 24)"
            strokeWidth="2"
            d="M18.5 12.5l12 12-12 12"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'arrow-r':
      return (
        <svg viewBox="0 0 48 48">
          <path
            strokeWidth="2"
            d="M18.5 12.5l12 12-12 12"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'arrow-down':
      return (
        <svg viewBox="0 0 48 48">
          <path
            transform="rotate(90 24 24)"
            strokeWidth="2"
            d="M18.5 12.5l12 12-12 12"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'arrow-down-fill':
      return (
        <svg viewBox="0 0 48 48">
          <path
            transform="rotate(90 24 24)"
            fill="#001640"
            d="M18.5 12.5l12 12-12 12"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'arrow-up':
      return (
        <svg viewBox="0 0 48 48">
          <path
            transform="rotate(-90 24 24)"
            strokeWidth="2"
            d="M18.5 12.5l12 12-12 12"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'arrow-up-fill':
      return (
        <svg viewBox="0 0 48 48">
          <path
            transform="rotate(-90 24 24)"
            fill="#001640"
            d="M18.5 12.5l12 12-12 12"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'arrow-big-right':
    case 'arrow-big-r':
      return (
        <svg viewBox="0 0 48 48">
          <g strokeWidth="2">
            <path
              vectorEffect="non-scaling-stroke"
              d="m22.856 16.618 7.917 7.917-7.917 7.918"
            />
            <path vectorEffect="non-scaling-stroke" d="M9 24.536h20.783" />
          </g>
        </svg>
      );
    case 'arrow-big-down':
      return (
        <svg viewBox="0 0 48 48">
          <line
            vectorEffect="non-scaling-stroke"
            x1="23.5"
            y1="0"
            x2="23.5"
            y2="26"
            strokeWidth="2"
          />
          <path
            vectorEffect="non-scaling-stroke"
            transform="rotate(90 24 24)"
            strokeWidth="2"
            d="M18.5 12.5l12 12-12 12"
          />
        </svg>
      );
    case 'sort':
      return (
        <svg viewBox="0 0 48 48">
          <path vectorEffect="non-scaling-stroke" d="m12 19 6 9.6 6-9.6" />
          <path vectorEffect="non-scaling-stroke" d="m24 28.6 6-9.6 6 9.6" />
        </svg>
      );
    case 'close':
    case 'cancel':
    case 'remove':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(14 14)" strokeWidth="2">
            <line x2="20" y2="20" vectorEffect="non-scaling-stroke" />
            <line
              transform="translate(20 0) rotate(90)"
              x2="20"
              y2="20"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'remove-big':
      return (
        <svg viewBox="0 0 48 48">
          <circle
            cx="24"
            cy="24"
            r="18"
            fill="#ff8089"
            stroke="none"
            vectorEffect="non-scaling-stroke"
          />
          <line
            strokeWidth="2"
            strokeLinecap="square"
            stroke="#fff"
            x1="18.5"
            y1="24"
            x2="31.5"
            y2="24"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'trash':
    case 'delete':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="scale(2) translate(0, -10)">
            <path d="M6 19.333V30h12V19.333M10.012 14.463s0-1.963 1.988-1.963c1.987 0 1.987 1.963 1.987 1.963M6 17h12M9 20v8M12 20v8M15 20v8" />
          </g>
        </svg>
      );
    case 'plus':
      return (
        <svg viewBox="0 0 48 48">
          <line
            x1="24"
            y1="16"
            x2="24"
            y2="32"
            vectorEffect="non-scaling-stroke"
          />
          <line
            x1="16"
            y1="24"
            x2="32"
            y2="24"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'minus':
      return (
        <svg viewBox="0 0 48 48">
          <line
            x1="16"
            y1="24"
            x2="32"
            y2="24"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'place':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-62 -206)">
            <path
              d="M77.012 229.874l6.68 13.361a2.118 2.118 0 003.789 0l6.68-13.361a9.587 9.587 0 00-1.8-11.067 9.587 9.587 0 00-13.558 0 9.587 9.587 0 00-1.791 11.067z"
              vectorEffect="non-scaling-stroke"
            />
            <circle
              cx="3.832"
              cy="3.832"
              transform="translate(81.756 221.353)"
              r="3.832"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'burger':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(14 14)" strokeWidth="2">
            <line
              x2="20"
              transform="translate(0 18)"
              vectorEffect="non-scaling-stroke"
            />
            <line
              x2="12"
              transform="translate(8 9)"
              vectorEffect="non-scaling-stroke"
            />
            <line x2="20" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'globe':
    case 'currency':
    case 'website':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-484.063 -271.465)">
            <circle
              cx="12"
              cy="12"
              r="12"
              transform="translate(496.063 283.465)"
            />
            <ellipse
              cx="9.6"
              cy="12"
              rx="9.6"
              ry="12"
              transform="translate(498.463 283.465)"
            />
            <ellipse
              cx="4.8"
              cy="12"
              rx="4.8"
              ry="12"
              transform="translate(503.263 283.465)"
            />
            <path d="M496.063 295.465h24M498.463 288.265h19.2M498.463 302.665h19.2" />
          </g>
        </svg>
      );
    case 'globe-big': //stroke-miterlimit:10
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-484.063 -271.465)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="12"
              cy="12"
              r="12"
              transform="translate(496.063 283.465)"
            />
            <ellipse
              vectorEffect="non-scaling-stroke"
              cx="9.6"
              cy="12"
              rx="9.6"
              ry="12"
              transform="translate(498.463 283.465)"
            />
            <ellipse
              vectorEffect="non-scaling-stroke"
              cx="4.8"
              cy="12"
              rx="4.8"
              ry="12"
              transform="translate(503.263 283.465)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M496.063 295.465h24M498.463 288.265h19.2M498.463 302.665h19.2"
            />
          </g>
        </svg>
      );
    case 'search':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-62 -206)" strokeWidth="2">
            <circle
              cx="12.701"
              cy="12.701"
              r="12.701"
              transform="translate(72 216)"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M94.21 238.21L102 246" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'account-big':
      return (
        <svg viewBox="0 0 80 40">
          <g strokeWidth="2">
            <path d="M44 29h20" vectorEffect="non-scaling-stroke">
              <animate
                attributeName="d"
                to="M52 29h12"
                dur="0.2s"
                begin="theRect.mouseover"
                repeatCount="1"
                fill="freeze"
              />
              <animate
                attributeName="d"
                to="M44 29h20"
                dur="0.2s"
                begin="theRect.mouseout"
                repeatCount="1"
                fill="freeze"
              />
            </path>
            <path d="M52 20h12m-20-9h20" vectorEffect="non-scaling-stroke">
              <animate
                attributeName="d"
                to="M44 20h20m-12-9h12"
                dur="0.2s"
                begin="theRect.mouseover"
                repeatCount="1"
                fill="freeze"
              />
              <animate
                attributeName="d"
                to="M52 20h12m-20-9h20"
                dur="0.2s"
                begin="theRect.mouseout"
                repeatCount="1"
                fill="freeze"
              />
            </path>

            <g transform="translate(8 8)">
              <circle
                cx="12"
                cy="12"
                r="11"
                vectorEffect="non-scaling-stroke"
              />
              <circle
                cx="12"
                cy="12"
                r="12"
                stroke="none"
                style={{ stroke: 'none' }}
                vectorEffect="non-scaling-stroke"
              />
            </g>
            <g strokeMiterlimit="10" transform="translate(10 8)">
              <circle
                cx="2.326"
                cy="2.326"
                r="2.326"
                transform="translate(7.674 6.057)"
                vectorEffect="non-scaling-stroke"
              />
              <path
                d="M5.341 17.222v-.847a2.489 2.489 0 0 1 2.541-2.541h4.235a2.489 2.489 0 0 1 2.541 2.541v.847"
                vectorEffect="non-scaling-stroke"
              />
            </g>
            <rect
              width="80"
              height="40"
              stroke="none"
              style={{ stroke: 'none' }}
              rx="20"
              vectorEffect="non-scaling-stroke"
            />
            <rect
              width="78"
              height="38"
              x="1"
              y="1"
              rx="19"
              vectorEffect="non-scaling-stroke"
            />
          </g>
          <rect
            width="100%"
            height="100%"
            stroke="none"
            style={{ stroke: 'none' }}
            pointerEvents="all"
            id="theRect"
          />
        </svg>
      );
    //       <svg xmlns="http://www.w3.org/2000/svg" data-name="Modules / Off-Canvas Menue" viewBox="0 0 80 40">
    //   <g fill="none" stroke="#001640" stroke-width="2" data-name="Atoms / Burger Button">
    //     <path d="M52 29h12"/>
    //     <path d="M44 20h20m-12-9h12" data-name="Line"/>
    //   </g>
    //   <g fill="none" stroke="#001640" stroke-width="2" data-name="Atoms / Login Button">
    //     <g stroke-miterlimit="10" data-name="Gruppe 79" transform="translate(10 8)">
    //       <circle cx="2.326" cy="2.326" r="2.326" data-name="Ellipse 19" transform="translate(7.674 6.057)"/>
    //       <path d="M5.341 17.222v-.847a2.489 2.489 0 0 1 2.541-2.541h4.235a2.489 2.489 0 0 1 2.541 2.541v.847" data-name="Pfad 122"/>
    //     </g>
    //     <g data-name="Ellipse 20" transform="translate(8 8)">
    //       <circle cx="12" cy="12" r="12" stroke="none"/>
    //       <circle cx="12" cy="12" r="11"/>
    //     </g>
    //   </g>
    //   <g fill="none" stroke="#001640" stroke-width="2" data-name="Rechteck 131">
    //     <rect width="80" height="40" stroke="none" rx="20"/>
    //     <rect width="78" height="38" x="1" y="1" rx="19"/>
    //   </g>
    // </svg>
    case 'account':
    case 'profile':
    case 'login':
      return (
        <svg viewBox="0 0 48 48">
          <g strokeWidth="2">
            <g transform="translate(6 2) scale(1.8)">
              <circle
                cx="2.326"
                cy="2.326"
                transform="translate(7.674 6.057)"
                r="2.326"
              />
              <path d="M5.341 17.222v-.847a2.489 2.489 0 0 1 2.541-2.541h4.235a2.489 2.489 0 0 1 2.541 2.541v.847" />
            </g>
            <circle cx="24" cy="24" r="22" vectorEffect="non-scaling-stroke" />
          </g>
          {/* <g strokeWidth="2" transform="translate(10 8) scale(1.2)">
            <g transform="translate(0 1)">
              <circle cx="12" cy="12" r="12" />
            </g>
          </g> */}
        </svg>
      );
    case 'logout':
      return (
        <svg viewBox="0 0 48 48">
          <g strokeWidth="2">
            <path
              vectorEffect="non-scaling-stroke"
              d="m22.856 16.618 7.917 7.917-7.917 7.918"
            />
            <path vectorEffect="non-scaling-stroke" d="M9 24.536h20.783" />
            <path vectorEffect="non-scaling-stroke" d="M30.773 12h8v24h-8" />
          </g>
        </svg>
      );
    case 'locked':
    case 'password':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M14 21.793h20.571v13.056H14z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.264 21.793v-3.264a6.557 6.557 0 0 1 7.021-6.528 6.558 6.558 0 0 1 7.022 6.528v3.264"
          />
        </svg>
      );
    case 'check':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="m11.452 25 10.552 7.118L34 14.333"
            strokeWidth="2"
          />
        </svg>
      );
    case 'check-big':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            strokeLinecap="butt"
            strokeWidth="4"
            d="m11.452 25 10.552 7.118L34 14.333"
          />
        </svg>
      );
    case 'dash':
      return (
        <svg viewBox="0 0 48 48">
          <path
            strokeWidth="4"
            stroke="#AEBDC4"
            strokeLinecap="square"
            d="M21.5 24.5h6"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'edit':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M29.615 8.553 12.923 25.245a1.89 1.89 0 0 0-.523 1l-1.369 7.527a1.891 1.891 0 0 0 2.2 2.2l7.527-1.369a1.89 1.89 0 0 0 1-.523L38.45 17.388a1.89 1.89 0 0 0 0-2.673l-6.158-6.158a1.89 1.89 0 0 0-2.677-.004Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m12.506 25.663 8.831 8.831"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m26.536 11.633 8.831 8.831"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'images':
    case 'image':
      return (
        <svg viewBox="0 0 32 32">
          <g transform="translate(5.333 7.333)">
            <rect
              vectorEffect="non-scaling-stroke"
              width="20.945"
              height="17.455"
              rx="3"
              transform="translate(.194 .194)"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="2.428"
              cy="2.428"
              r="2.428"
              transform="translate(5.18 3.113)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="m1.939 14.158 3.491-3.491 3.491 3.491 6.982-6.982 3.491 3.491"
            />
          </g>
        </svg>
      );
    case 'eye':
    case 'show':
    case 'publish':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M8 23.957a17.834 17.834 0 0 1 32 0 17.834 17.834 0 0 1-32 0Z"
          />
          <g transform="translate(17.843 17.8)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="6.157"
              cy="6.157"
              r="6.157"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="3.462"
              cy="3.462"
              r="3.462"
              transform="translate(2.695 2.695)"
            />
          </g>
        </svg>
      );
    case 'hide':
      return (
        <svg viewBox="0 0 48 48">
          <line
            x1="36"
            y1="12"
            x2="12"
            y2="36"
            vectorEffect="non-scaling-stroke"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M8 23.957a17.834 17.834 0 0 1 32 0 17.834 17.834 0 0 1-32 0Z"
          />
          <g transform="translate(17.843 17.8)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="6.157"
              cy="6.157"
              r="6.157"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="3.462"
              cy="3.462"
              r="3.462"
              transform="translate(2.695 2.695)"
            />
          </g>
        </svg>
      );
    case 'add':
    case 'signup':
      return (
        <svg viewBox="0 0 48 48">
          <g strokeWidth="2">
            <line
              vectorEffect="non-scaling-stroke"
              x1="24"
              y1="16"
              x2="24"
              y2="32"
            />
            <line
              vectorEffect="non-scaling-stroke"
              x1="16"
              y1="24"
              x2="32"
              y2="24"
            />
            <circle vectorEffect="non-scaling-stroke" cx="24" cy="24" r="22" />
          </g>
        </svg>
      );
    case 'send':
      return (
        <svg viewBox="0 0 48 48">
          <g strokeLinejoin="round">
            <path
              vectorEffect="non-scaling-stroke"
              d="m10.852 14.331 4.42 10.67 25.02-8.577Z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="m16.535 28.05 23.757-11.626L20.955 38.72Z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M15.272 25.002 11.7 33.624l6.098-2.525"
            />
          </g>
        </svg>
      );
    case 'expand':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="m36 12-9.6 9.6M26.4 12H36v9.6M12 36l9.6-9.6M21.6 36H12v-9.6"
          />
        </svg>
      );
    case 'company':
    case 'job':
      return (
        <svg viewBox="0 0 48 48">
          <path vectorEffect="non-scaling-stroke" d="M10 42.334V5h28v37.333" />
          <path
            vectorEffect="non-scaling-stroke"
            d="M15.041 11.586h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M22.208 11.586h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M29.376 11.586h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M15.041 18.753h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M22.208 18.753h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M29.376 18.753h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M15.041 25.921h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M22.208 25.921h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M29.376 25.921h3.584v3.584h-3.584z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.334 42.334v-9.33h9.333v9.333"
          />
        </svg>
      );
    case 'location':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-62 -206)">
            <path
              d="m77.012 229.874 6.68 13.361a2.118 2.118 0 0 0 3.789 0l6.68-13.361a9.587 9.587 0 0 0-1.8-11.067 9.587 9.587 0 0 0-13.558 0 9.587 9.587 0 0 0-1.791 11.067Z"
              vectorEffect="non-scaling-stroke"
            />
            <circle
              cx="3.832"
              cy="3.832"
              transform="translate(81.756 221.353)"
              r="3.832"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    // case 'map':
    //   return (
    //     <svg viewBox='0 0 48 48'>
    //       <path
    //         vectorEffect='non-scaling-stroke'
    //         d='M30.4 10.057a9.264 9.264 0 0 0-13.1 0 9.264 9.264 0 0 0-1.735 10.694l5.522 11.044a3.09 3.09 0 0 0 5.528 0l5.522-11.044A9.264 9.264 0 0 0 30.4 10.057Zm-6.551 10.512a4.009 4.009 0 1 1 4.009-4.009 4.009 4.009 0 0 1-4.009 4.008Z'
    //       />
    //       <path
    //         vectorEffect='non-scaling-stroke'
    //         d='m15.546 31.044-8.3 8.3h33.213l-8.3-8.3'
    //       />
    //     </svg>
    //   );
    case 'list':
      return (
        <svg viewBox="0 0 48 48">
          <path vectorEffect="non-scaling-stroke" d="M10 15h4.667" />
          <path vectorEffect="non-scaling-stroke" d="M19.333 15H38" />
          <path vectorEffect="non-scaling-stroke" d="M10 24.334h4.667" />
          <path vectorEffect="non-scaling-stroke" d="M19.333 24.334H38" />
          <path vectorEffect="non-scaling-stroke" d="M10 33.667h4.667" />
          <path vectorEffect="non-scaling-stroke" d="M19.333 33.667H38" />
        </svg>
      );
    case 'venue':
      return (
        <svg viewBox="0 0 96 96">
          <path
            d="M24 25.694v35.308M72 40.32V61M80 41a79.72 79.72 0 0 1-32-8 79.72 79.72 0 0 0-32-8M40 61V49s0-4 4.8-4H52s4 0 4 4v12M16 61h64"
            vectorEffect="non-scaling-stroke"
            transform="translate(0, 4)"
          />
        </svg>
      );
    case 'venues':
      return (
        <svg viewBox="0 0 96 96">
          <path
            vectorEffect="non-scaling-stroke"
            d="m12 30.5 9 9V71M75 47.735V71M12 26a89.685 89.685 0 0 1 36 9 89.685 89.685 0 0 0 36 9v4.5a89.685 89.685 0 0 1-36-9 89.685 89.685 0 0 0-36-9ZM39 62s0-4.5 5.4-4.5h8.1s4.5 0 4.5 4.5"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M30 71V39.5l-8.088-8.088M39 39.5V71M48 39.5v18M57 43.321V71M66 45.997V71M21 39.5h27M21 48.5h63M21 57.5h18M57 57.5h18M12 71h72M39 39.5l-5.607-5.607"
          />
        </svg>
      );
    case 'hotel':
      return (
        <svg viewBox="0 0 96 96">
          <path
            vectorEffect="non-scaling-stroke"
            d="M18 30v36.667M78 36.667v30"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M18 46h60v14H18zM67.382 45.735c0-13.735-10-13.735-10-13.735h-20c-10 0-10 13.735-10 13.735"
          />
        </svg>
      );
    case 'hotels':
      return (
        <svg viewBox="0 0 96 96">
          <path
            d="M18 30v36.667M78 36.667v30"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M18 50h60v10H18zM78 50c0-10-10-10-10-10H48c-10 0-10 10-10 10 0-10-10-10-10-10h-6.667A3.265 3.265 0 0 0 18 43.333"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'service':
    case 'catering':
    case 'rigging':
    case 'service-provider':
    case 'serviceprovider':
    case 'serviceProvider':
      return (
        <svg viewBox="0 0 96 96">
          <path
            vectorEffect="non-scaling-stroke"
            d="M53.923 37.827v-3.951a3.951 3.951 0 1 0-1.316-7.672 5.923 5.923 0 0 0-9.221 0 3.949 3.949 0 1 0-1.316 7.672v7.9s0 5.926 5.926 5.926 5.926-5.926 5.926-5.926v-3.951M34.173 68.479v-9.877c0-5.923 5.926-5.923 5.926-5.923h15.8s5.926 0 5.926 5.926v9.874M68.295 34.676v5.644s0 5.644 5.644 5.644 5.644-5.644 5.644-5.644v-5.644M64.532 34.676h18.813"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M66.413 34.677v-1.881a7.525 7.525 0 1 1 15.05 0v1.881M67.617 50.888h12.642s4.741 0 4.741 4.741v7.9M10 63.53v-7.9c0-4.741 4.741-4.741 4.741-4.741h12.642M11.58 46.309v-7.9s0-9.482 9.481-9.482 9.481 9.482 9.481 9.482v7.9"
          />
        </svg>
      );
    case 'services':
    case 'service-providers':
    case 'serviceProviders':
    case 'serviceproviders':
      return (
        <svg viewBox="0 0 96 96">
          <path
            vectorEffect="non-scaling-stroke"
            d="M55.407 24.469a4.918 4.918 0 0 0-1.644.286 7.4 7.4 0 0 0-11.526 0 4.936 4.936 0 1 0-1.644 9.59v4.938h14.815v-4.938a4.938 4.938 0 1 0 0-9.877ZM40.593 39.284v4.938s0 7.407 7.407 7.407 7.407-7.407 7.407-7.407v-4.938"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M43.062 50.037v4.062L48 59.037l4.938-4.938v-4.132M43.062 54.099h-4.938s-7.408 0-7.408 7.407v12.346M52.938 54.099h4.938s7.407 0 7.407 7.407v12.346M48 59.037v14.815M68.247 39.284v5.926s0 5.926 5.926 5.926 5.926-5.926 5.926-5.926v-5.926M78.124 53.112v-3.306M70.222 49.861v3.25M68.247 53.112v9.877h11.852v-9.877M82.074 53.112v9.877H88M64.296 39.284h19.753"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M66.272 39.285v-1.977a7.9 7.9 0 0 1 15.8 0v1.975M66.272 53.112h3.951c0 3.951 3.951 3.951 3.951 3.951s3.951 0 3.951-3.951h3.947s5.926 0 5.926 5.926v9.874M27.753 41.258v3.951s0 5.926-5.926 5.926-5.926-5.925-5.926-5.925v-7.9s3.951 0 3.951-3.951c0 0 0 7.9 7.9 7.9M25.778 53.112v-3.306M17.877 49.861v3.25M8 68.912v-9.877c0-5.926 5.926-5.926 5.926-5.926h3.951c0 3.951 3.951 3.951 3.951 3.951s3.951 0 3.951-3.951h3.951"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.875 51.136h-7.9V41.26s0-11.852 11.852-11.852S33.675 41.26 33.675 41.26v9.876h-7.9"
          />
        </svg>
      );
    case 'marker_venue':
    case 'marker_venue_basic':
      return (
        <svg viewBox="0 0 48 48">
          <defs>
            <linearGradient
              id="marker_venue_gradient_basic"
              x1=".5"
              x2=".5"
              y1="1.005"
              y2=".031"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stopColor="#006cff" />
              <stop offset="1" stopColor="#60d3bd" />
            </linearGradient>
          </defs>
          <path
            stroke="none"
            fill="url(#marker_venue_gradient_basic)"
            d="M7.45 4.686a16 16 0 0 0-3 18.468l6.929 13.859a8.25 8.25 0 0 0 14.759 0l6.929-13.859a16 16 0 0 0-3-18.468 16 16 0 0 0-22.617 0Z"
            transform="translate(5.236 3)"
            vectorEffect="non-scaling-stroke"
          />
          <g stroke="#fff">
            <path d="M16 13.566v11.769" vectorEffect="non-scaling-stroke" />
            <path d="M32 18.44v6.893" vectorEffect="non-scaling-stroke" />
            <path
              d="M34.666 18.666a26.573 26.573 0 0 1-10.667-2.667 26.574 26.574 0 0 0-10.666-2.666"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M21.333 25.333v-4a1.4 1.4 0 0 1 1.6-1.333h2.4a1.306 1.306 0 0 1 1.333 1.333v4"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M13.333 25.333h21.333" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'marker_venue_gold':
      return (
        <svg viewBox="0 0 48 48">
          <defs>
            <linearGradient
              id="marker_venue_gradient_platinum"
              x1=".5"
              x2=".5"
              y1="1.005"
              y2=".031"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stopColor="#60D3BD" />
              <stop offset="1" stopColor="#006CFF" />
            </linearGradient>
          </defs>
          <path
            stroke={'#d6c3ae'}
            strokeWidth={2}
            fill="url(#marker_venue_gradient_platinum)"
            d="M7.45 4.686a16 16 0 0 0-3 18.468l6.929 13.859a8.25 8.25 0 0 0 14.759 0l6.929-13.859a16 16 0 0 0-3-18.468 16 16 0 0 0-22.617 0Z"
            transform="translate(5.236 3)"
            vectorEffect="non-scaling-stroke"
          />
          <g stroke="#fff">
            <path d="M16 13.566v11.769" vectorEffect="non-scaling-stroke" />
            <path d="M32 18.44v6.893" vectorEffect="non-scaling-stroke" />
            <path
              d="M34.666 18.666a26.573 26.573 0 0 1-10.667-2.667 26.574 26.574 0 0 0-10.666-2.666"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M21.333 25.333v-4a1.4 1.4 0 0 1 1.6-1.333h2.4a1.306 1.306 0 0 1 1.333 1.333v4"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M13.333 25.333h21.333" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'marker_venue_platinum':
      return (
        <svg viewBox="0 0 48 48">
          <defs>
            <linearGradient
              id="marker_venue_gradient_platinum"
              x1=".5"
              x2=".5"
              y1="1.005"
              y2=".031"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stopColor="#60D3BD" />
              <stop offset="1" stopColor="#006CFF" />
            </linearGradient>
          </defs>
          <path
            stroke={'#d6c3ae'}
            strokeWidth={3}
            fill="url(#marker_venue_gradient_platinum)"
            d="M7.45 4.686a16 16 0 0 0-3 18.468l6.929 13.859a8.25 8.25 0 0 0 14.759 0l6.929-13.859a16 16 0 0 0-3-18.468 16 16 0 0 0-22.617 0Z"
            transform="translate(5.236 3)"
            vectorEffect="non-scaling-stroke"
          />
          <g stroke="#fff">
            <path d="M16 13.566v11.769" vectorEffect="non-scaling-stroke" />
            <path d="M32 18.44v6.893" vectorEffect="non-scaling-stroke" />
            <path
              d="M34.666 18.666a26.573 26.573 0 0 1-10.667-2.667 26.574 26.574 0 0 0-10.666-2.666"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M21.333 25.333v-4a1.4 1.4 0 0 1 1.6-1.333h2.4a1.306 1.306 0 0 1 1.333 1.333v4"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M13.333 25.333h21.333" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M7.45 4.686a16 16 0 0 0-3 18.468l6.929 13.859a8.25 8.25 0 0 0 14.759 0l6.929-13.859a16 16 0 0 0-3-18.468 16 16 0 0 0-22.617 0Z"
            transform="translate(5.236 3)"
            vectorEffect="non-scaling-stroke"
          />
          <g stroke="#fff">
            <path d="M16 13.566v11.769" vectorEffect="non-scaling-stroke" />
            <path d="M32 18.44v6.893" vectorEffect="non-scaling-stroke" />
            <path
              d="M34.666 18.666a26.573 26.573 0 0 1-10.667-2.667 26.574 26.574 0 0 0-10.666-2.666"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M21.333 25.333v-4a1.4 1.4 0 0 1 1.6-1.333h2.4a1.306 1.306 0 0 1 1.333 1.333v4"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M13.333 25.333h21.333" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'marker_provider':
    case 'marker_service':
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#60d3bd"
            d="M12.686 7.686a16 16 0 0 0-3 18.468l6.929 13.859a8.25 8.25 0 0 0 14.759 0l6.929-13.859a16 16 0 0 0-3-18.468 16 16 0 0 0-22.617 0Z"
            vectorEffect="non-scaling-stroke"
          />
          <g stroke="#fff">
            <path
              d="M25.975 17.609v-1.317a1.317 1.317 0 1 0-.439-2.557 1.974 1.974 0 0 0-3.074 0 1.316 1.316 0 1 0-.439 2.557v2.634a1.976 1.976 0 1 0 3.951 0v-1.317"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M19.391 27.828v-3.292a1.935 1.935 0 0 1 1.975-1.976h5.267a1.935 1.935 0 0 1 1.975 1.975v3.292"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M30.765 16.559v1.881a1.881 1.881 0 0 0 3.763 0v-1.881"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M29.511 16.559h6.271" vectorEffect="non-scaling-stroke" />
            <path
              d="M30.138 16.559v-.627a2.509 2.509 0 0 1 5.017 0v.627"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M30.539 21.963h4.214a1.548 1.548 0 0 1 1.58 1.58v2.634"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M11.333 26.177v-2.634a1.548 1.548 0 0 1 1.58-1.58h4.214"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M11.86 20.436v-2.634a3.16 3.16 0 1 1 6.321 0v2.634"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'marker_hotel':
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M12.686 7.686a16 16 0 0 0-3 18.468l6.929 13.859a8.25 8.25 0 0 0 14.759 0l6.929-13.859a16 16 0 0 0-3-18.468 16 16 0 0 0-22.617 0Z"
            vectorEffect="non-scaling-stroke"
          />
          <g stroke="#fff">
            <path d="M14 15v12.222" vectorEffect="non-scaling-stroke" />
            <path d="M34 17.222v10" vectorEffect="non-scaling-stroke" />
            <path d="M14 20.333h20V25H14z" vectorEffect="non-scaling-stroke" />
            <path
              d="M30.46 20.245c0-4.578-3.333-4.578-3.333-4.578H20.46c-3.333 0-3.333 4.578-3.333 4.578"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'preferred':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-649 -1244)">
            <circle
              cx="10"
              cy="10"
              r="10"
              fill="#001640"
              vectorEffect="non-scaling-stroke"
              transform="translate(663 1258)"
            />
            <path
              fill="none"
              stroke="#fff"
              d="m668.007 1269.265 4.807 3.243 5.468-8.103"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'owned':
      return (
        <svg viewBox="0 0 48 48">
          <path d="M10.5 11.002v25" vectorEffect="non-scaling-stroke" />
          <path d="M37.5 19.5v16.501" vectorEffect="non-scaling-stroke" />
          <path
            d="M42 20a44.843 44.843 0 0 1-18-4.5A44.843 44.843 0 0 0 6 11"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M6 36h36" vectorEffect="non-scaling-stroke" />
          <g transform="translate(-646.634 -1239.634)">
            <circle
              cx="8.5"
              cy="8.5"
              r="8.5"
              fill="#001640"
              vectorEffect="non-scaling-stroke"
              transform="translate(662.634 1257.634)"
            />
            <path
              fill="none"
              stroke="#fff"
              d="m667.073 1267.163 3.911 2.638 4.445-6.591"
            />
          </g>
        </svg>
      );
    case 'unanswered':
      return (
        <svg viewBox="0 0 32 32">
          <circle
            cx="12"
            cy="12"
            r="12"
            fill="#ff8089"
            stroke="none"
            transform="translate(4 4)"
          />
        </svg>
      );
    case 'proposed':
      return (
        <svg viewBox="0 0 32 32">
          <circle
            cx="12"
            cy="12"
            r="12"
            fill="#006cff"
            stroke="none"
            transform="translate(4 4)"
          />
          <g
            strokeWidth="2.5"
            stroke="#fff"
            strokeLinecap="square"
            strokeLinejoin="miter"
            transform="translate(12 12)"
          >
            <line x1="9" x2="4" y2="7" vectorEffect="non-scaling-stroke" />
            <line
              x1="0"
              y1="4"
              x2="4"
              y2="7"
              vectorEffect="non-scaling-stroke"
            />
          </g>
          -
        </svg>
      );
    case 'rejected':
      return (
        <svg viewBox="0 0 32 32">
          <circle
            cx="12"
            cy="12"
            r="12"
            fill="#aebdc4"
            stroke="none"
            transform="translate(4 4)"
          />
          <g
            strokeWidth="2.5"
            stroke="#fff"
            strokeLinecap="square"
            strokeLinejoin="miter"
            transform="translate(12 12)"
          >
            <line x2="8" y2="8" vectorEffect="non-scaling-stroke" />
            <line x1="8" y2="8" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'promoted':
      return (
        <svg viewBox="0 0 48 48">
          <circle
            cx="13"
            cy="13"
            r="13"
            fill="#006cff"
            stroke="none"
            transform="translate(11 11)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="square"
            d="m19.028 24.292 4.745 3.2 5.394-7.997"
          />
        </svg>
      );
    case 'approved':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(11 11)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="13"
              cy="13"
              r="13"
              stroke="none"
              style={{ stroke: 'none' }}
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="13"
              cy="13"
              r="12.5"
            />
          </g>
          <path
            vectorEffect="non-scaling-stroke"
            d="m19.028 24.292 4.745 3.2 5.394-7.997"
          />
        </svg>
      );
    case 'free':
    case 'basic':
    case 'star':
    case 'rating':
    case 'star-basic':
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="m24.797 11.998 3.644 5.9a.841.841 0 0 0 .518.376l6.737 1.643a.844.844 0 0 1 .444 1.366l-4.485 5.289a.843.843 0 0 0-.2.609l.52 6.915a.844.844 0 0 1-1.162.844l-6.416-2.631a.839.839 0 0 0-.64 0l-6.416 2.631a.844.844 0 0 1-1.162-.844l.52-6.915a.843.843 0 0 0-.2-.609l-4.485-5.289a.844.844 0 0 1 .444-1.366l6.737-1.643a.841.841 0 0 0 .518-.376l3.645-5.9a.844.844 0 0 1 1.439 0Z"
          />
        </svg>
      );
    case 'star-outline':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="m24.797 11.998 3.644 5.9a.841.841 0 0 0 .518.376l6.737 1.643a.844.844 0 0 1 .444 1.366l-4.485 5.289a.843.843 0 0 0-.2.609l.52 6.915a.844.844 0 0 1-1.162.844l-6.416-2.631a.839.839 0 0 0-.64 0l-6.416 2.631a.844.844 0 0 1-1.162-.844l.52-6.915a.843.843 0 0 0-.2-.609l-4.485-5.289a.844.844 0 0 1 .444-1.366l6.737-1.643a.841.841 0 0 0 .518-.376l3.645-5.9a.844.844 0 0 1 1.439 0Z"
          />
        </svg>
      );
    case 'gold':
    case 'star-gold': //scope
    case 'star-service-provider': //scope
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            vectorEffect="non-scaling-stroke"
            fill="#001640"
            d="m24.797 11.998 3.644 5.9a.841.841 0 0 0 .518.376l6.737 1.643a.844.844 0 0 1 .444 1.366l-4.485 5.289a.843.843 0 0 0-.2.609l.52 6.915a.844.844 0 0 1-1.162.844l-6.416-2.631a.839.839 0 0 0-.64 0l-6.416 2.631a.844.844 0 0 1-1.162-.844l.52-6.915a.843.843 0 0 0-.2-.609l-4.485-5.289a.844.844 0 0 1 .444-1.366l6.737-1.643a.841.841 0 0 0 .518-.376l3.645-5.9a.844.844 0 0 1 1.439 0Z"
          />
        </svg>
      );
    case 'platinum':
    case 'star-platinum':
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            vectorEffect="non-scaling-stroke"
            fill="#d6c3ae"
            d="m24.797 11.998 3.644 5.9a.841.841 0 0 0 .518.376l6.737 1.643a.844.844 0 0 1 .444 1.366l-4.485 5.289a.843.843 0 0 0-.2.609l.52 6.915a.844.844 0 0 1-1.162.844l-6.416-2.631a.839.839 0 0 0-.64 0l-6.416 2.631a.844.844 0 0 1-1.162-.844l.52-6.915a.843.843 0 0 0-.2-.609l-4.485-5.289a.844.844 0 0 1 .444-1.366l6.737-1.643a.841.841 0 0 0 .518-.376l3.645-5.9a.844.844 0 0 1 1.439 0Z"
          />
        </svg>
      );
    case 'boost':
    case 'rocket':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="scale(1.1) translate(-1 -1)">
            <path
              vectorEffect="non-scaling-stroke"
              d="m22.024 15.862-5.51 5.51-5.516-1.838 3.677-3.677Z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="m33.042 26.88-5.51 5.51 1.838 5.515 3.677-3.677Z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              strokeMiterlimit="0"
              d="M36.716 12.184a16.779 16.779 0 0 0-14.695 3.674l-7.348 7.348 11.021 11.02 7.348-7.347a16.779 16.779 0 0 0 3.674-14.695Zm-9.185 9.184a2.6 2.6 0 1 1 3.677 0 2.6 2.6 0 0 1-3.677 0Z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M12.737 24.949s-4.526 4.525-1.132 12.445a16.067 16.067 0 0 0 12.445-1.132"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M15 27.212a7.473 7.473 0 0 0-1.132 7.92A10.665 10.665 0 0 0 21.788 34"
            />
          </g>
        </svg>
      );
    case 'filter':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-200.598 -193.512)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="3"
              cy="3"
              r="3"
              transform="translate(215.598 205.512)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M221.598 208.512h15M212.598 208.512h3"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="3"
              cy="3"
              r="3"
              transform="translate(215.598 223.512)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M221.598 226.512h15M212.598 226.512h3"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="3"
              cy="3"
              r="3"
              transform="translate(227.598 214.512)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M233.598 217.512h3M212.598 217.512h15"
            />
          </g>
        </svg>
      );
    /*
     * Property icons
     */
    case 'm2':
    case 'area':
    case 'space':
    case 'indoor':
    case 'event_space':
    case 'rfp_event_space':
    case 'required_capacity_max':
    case 'exhibition_space_m2':
    case 'exhibition_indoor_m2':
    case 'conference_total_m2':
    case 'conference_largest_room_m2':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="m24 25-12 6 12 6 12-6ZM24 13l-12 6 12 6 12-6Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M12 19v12M24 25v12M36 19v12"
          />
        </svg>
      );
    case 'outside':
    case 'outdoor':
    case 'exhibition_outdoor_m2':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M24.21 18.445a5.016 5.016 0 1 1 6.345 6.342"
          />
          <path vectorEffect="non-scaling-stroke" d="M28.97 10v2.663" />
          <path
            vectorEffect="non-scaling-stroke"
            d="M36.063 12.937 34.18 14.82"
          />
          <path vectorEffect="non-scaling-stroke" d="M39 20.029h-2.663" />
          <path
            vectorEffect="non-scaling-stroke"
            d="m36.063 27.122-1.883-1.883"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="m23.761 14.82-1.883-1.883"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M29.017 28.45c-.067 0-.13.014-.2.02a6.738 6.738 0 0 0-12.643-4.538 5.013 5.013 0 1 0-2.164 9.534h15a2.507 2.507 0 1 0 0-5.015Z"
          />
        </svg>
      );
    case 'people':
    case 'capacity':
    case 'audience_capacity':
    case 'event_pax':
    case 'rfp_event_pax':
    case 'capacity_pax':
    case 'capacity_max':
    case 'conference_total_pax':
    case 'capacity_per_type':
      return (
        <svg viewBox="0 0 48 48">
          <circle
            vectorEffect="non-scaling-stroke"
            cx="4"
            cy="4"
            r="4"
            transform="translate(20 20)"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M20 28s-4 0-4 4v4h16v-4s0-4-4-4"
          />
          <circle
            vectorEffect="non-scaling-stroke"
            cx="4"
            cy="4"
            r="4"
            transform="translate(28 12)"
          />
          <path vectorEffect="non-scaling-stroke" d="M36 28h4v-4s0-4-4-4" />
          <circle
            vectorEffect="non-scaling-stroke"
            cx="4"
            cy="4"
            r="4"
            transform="translate(12 12)"
          />
          <path vectorEffect="non-scaling-stroke" d="M11.995 20s-4 0-4 4v4h4" />
        </svg>
      );
    case 'car':
    case 'parking':
    case 'car_parking':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-333.157 -375.764)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="4.533"
              cy="4.533"
              r="4.533"
              transform="translate(344.691 401.097)"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="4.533"
              cy="4.533"
              r="4.533"
              transform="translate(360.557 401.097)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M342.424 405.63h-2.267v-6.8l6.8-2.267 2.267-6.8h15.867l2.267 6.8 6.8 2.267v6.8h-2.267"
            />
          </g>
        </svg>
      );
    case 'discount':
    case 'discount_rate_offseason':
    case 'discount_rate_construction':
    case 'discount_offseason_perc':
    case 'discount_construction_perc':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-198.801 -368.88)">
            <path
              vectorEffect="non-scaling-stroke"
              d="m238.028 394.463-3.058 2.387a2.008 2.008 0 0 0-.758 1.828l.475 3.851a2.008 2.008 0 0 1-2.238 2.238l-3.85-.475a2.008 2.008 0 0 0-1.829.757l-2.387 3.058a2.008 2.008 0 0 1-3.165 0l-2.387-3.058a2.009 2.009 0 0 0-1.829-.757l-3.85.475a2.008 2.008 0 0 1-2.239-2.238l.475-3.851a2.007 2.007 0 0 0-.757-1.828l-3.058-2.387a2.008 2.008 0 0 1 0-3.166l3.058-2.387a2.007 2.007 0 0 0 .757-1.828l-.475-3.851a2.008 2.008 0 0 1 2.239-2.238l3.85.475a2.009 2.009 0 0 0 1.829-.757l2.387-3.058a2.008 2.008 0 0 1 3.165 0l2.387 3.058a2.008 2.008 0 0 0 1.829.757l3.85-.475a2.008 2.008 0 0 1 2.238 2.238l-.475 3.851a2.008 2.008 0 0 0 .758 1.828l3.058 2.387a2.008 2.008 0 0 1 0 3.166Z"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="2.23"
              cy="2.23"
              r="2.23"
              transform="translate(215.899 385.978)"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="2.23"
              cy="2.23"
              r="2.23"
              transform="translate(225.063 395.142)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="m215.899 399.782 13.804-13.804"
            />
          </g>
        </svg>
      );
    case 'event':
    case 'events':
    case 'date':
    case 'event_start':
    case 'event_end':
    case 'event_date':
    case 'rfp_event_start':
    case 'rfp_event_end':
    case 'rfp_event_date':
    case 'date_start':
    case 'date_end':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M38 15.333v21.778a3.047 3.047 0 0 1-3.111 3.111H13.111A3.047 3.047 0 0 1 10 37.111V15.333a3.047 3.047 0 0 1 3.111-3.111h21.778A3.047 3.047 0 0 1 38 15.333Z"
          />
          <path vectorEffect="non-scaling-stroke" d="M19.333 12.222V6" />
          <path vectorEffect="non-scaling-stroke" d="M31.778 12.222V6" />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M16.222 18.444h3.111v3.111h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M22.444 18.444h3.111v3.111h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M28.667 18.444h3.111v3.111h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M16.222 24.666h3.111v3.111h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M22.444 24.666h3.111v3.111h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M28.667 24.666h3.111v3.111h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M16.222 30.889h3.111V34h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M22.444 30.889h3.111V34h-3.111z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            fill="#aebdc4"
            d="M28.667 30.889h3.111V34h-3.111z"
          />
        </svg>
      );
    case 'srpsqm':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M29.625 15.875h-7.5s-3.75 0-3.75 3.75 3.75 3.75 3.75 3.75h3.75s3.75 0 3.75 3.75-3.75 3.75-3.75 3.75h-7.5"
          />
          <path vectorEffect="non-scaling-stroke" d="M24 14v18.75" />
          <path stroke="none" style={{ stroke: 'none' }} d="M11 10h26v27H11z" />
          <path vectorEffect="non-scaling-stroke" d="M11.5 10.5h25v26h-25z" />
        </svg>
      );
    case 'l_w_h':
    case 'length':
    case 'width':
    case 'height':
    case 'dimensions':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="m36 31.999-12-6-12 6M24 26V14M20.244 17.755 24 13.999l3.756 3.756"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.131 33.375 12 32l1.375-5.131M30.87 33.375 36.001 32l-1.375-5.131"
          />
        </svg>
      );

    case 'hall_max_m2':
    case 'hall_min_max_m2':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M19.909 12.5 6.728 22.385h3.3v13.18h19.771V22.386h3.295Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M34.089 35.564h8.244v-6.947h1.737l-6.947-5.21-3.033 2.275"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'hall_min_m2':
      return (
        //transform='scale(-1 1)'
        <svg viewBox="0 0 48 48">
          <path
            d="M19.909 12.5 6.728 22.385h3.3v13.18h19.771V22.386h3.295Z"
            vectorEffect="non-scaling-stroke"
            transform="scale(.7 .7) translate(1 18)"
          />
          <g transform="scale(2.1 2.1) translate(-22 -18)">
            <path
              d="M34.089 35.564h8.244v-6.947h1.737l-6.947-5.21-3.033 2.275"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'rfp_event_name':
    case 'event_name':
    case 'halls':
    case 'halls_count':
      // case "rooms":
      // case "rooms_count":
      // case "conference_rooms":
      // case "conference_rooms_count":
      // case "floors":
      // case "floors_ccount":
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.909 17.454 9 25.636h2.727v10.909h16.364V25.636h2.727Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M31.85 31.09h4.422V20.181h2.729l-10.909-8.182-4.764 3.573"
          />
        </svg>
      );
    case 'wifi':
    case 'free_wifi':
    case 'internet':
    case 'internet_wifi':
    case 'internet_lan':
    case 'internet_speed':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-467.159 -414.197)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="3.249"
              cy="3.249"
              r="3.249"
              transform="translate(487.993 444.693)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M484.346 441.051a9.748 9.748 0 0 1 13.786 0"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M479.754 436.453a16.247 16.247 0 0 1 22.976 0"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M475.159 431.859a22.746 22.746 0 0 1 32-.165"
            />
          </g>
        </svg>
      );
    case 'barrier_free_access':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M27.261 30.502a7.563 7.563 0 1 1-10.8-8.181"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M20.03 17.318v9.075h7.892l4.86 4.865 3.025-3.025"
          />
          <path vectorEffect="non-scaling-stroke" d="M27.591 21.111h-7.562" />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.004 14.292a3.025 3.025 0 1 1 3.022 3.025 3.025 3.025 0 0 1-3.022-3.025Z"
          />
        </svg>
      );
    case 'truck_parking':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-333.157 -375.764)">
            <circle
              cx="3.533"
              cy="3.533"
              r="3.533"
              vectorEffect="non-scaling-stroke"
              transform="translate(363.557 403.097)"
            />
            <circle
              cx="3.533"
              cy="3.533"
              r="3.533"
              vectorEffect="non-scaling-stroke"
              transform="translate(351.062 403.097)"
            />
            <circle
              cx="3.533"
              cy="3.533"
              r="3.533"
              vectorEffect="non-scaling-stroke"
              transform="translate(342.091 403.097)"
            />
            <path
              d="M342.424 405.63h-2.267v-6.8l22.424.144v-9.067h7.313l4.263 5.072v10.65h-2.267"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M340.157 399.042v-9.123h19.194v9.123"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'onsite_restaurants':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M17 14v4.313a2.948 2.948 0 0 0 3.011 3.01v14.459"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M23.021 14v4.313a2.948 2.948 0 0 1-3.011 3.01"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M20.01 21.323V14" vectorEffect="non-scaling-stroke" />
          <path
            d="M27.861 35.781V14.853c3.425 1.819 3.133 11.247 3.133 11.247h-3.133"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M38 22.224v-5.6h4.5l-18-12-18 12H11v5.6"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'onsite_restaurants_pax':
      return (
        <svg viewBox="0 0 48 48">
          <circle
            cx="4"
            cy="4"
            r="4"
            vectorEffect="non-scaling-stroke"
            transform="translate(26 8)"
          />
          <path d="M34 24h4v-4s0-4-4-4" vectorEffect="non-scaling-stroke" />
          <path
            d="M11 15v4.313a2.948 2.948 0 0 0 3.011 3.01v14.459"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M17.021 15v4.313a2.948 2.948 0 0 1-3.011 3.01"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M14.01 22.323V15" vectorEffect="non-scaling-stroke" />
          <path
            d="M21.861 36.781V15.853c3.425 1.819 3.133 11.247 3.133 11.247h-3.133"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'inhouse_catering':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M19 17v3.08a2.106 2.106 0 0 0 2.15 2.15v10.329"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M23.3 17v3.08a2.106 2.106 0 0 1-2.15 2.15"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M21.15 22.231V17" vectorEffect="non-scaling-stroke" />
          <path
            d="M26.758 32.559V17.61c2.446 1.3 2.238 8.034 2.238 8.034h-2.238"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m8.999 13.433 6 23.152h18l6-23.152Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M18.423 13.433v-1.858s0-5.576 5.576-5.576 5.576 5.576 5.576 5.576v1.858"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'broadcasting_studio':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M14.443 32.554a12.185 12.185 0 0 1 0-17.232"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M10.996 36a17.059 17.059 0 0 1-.124-24"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M34.446 15.446a12.185 12.185 0 0 1 0 17.232"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M37.893 12a17.059 17.059 0 0 1 .124 24"
            vectorEffect="non-scaling-stroke"
          />
          <g transform="translate(18 13)">
            <path
              d="M10.075 11.7v-1.631h1.631v-1.63h-1.631v-1.63h1.631V5.178h-1.631v-1.63h1.6C11.402.297 7.901.287 7.901.287h-3.8A3.532 3.532 0 0 0 .328 3.548h1.6v1.63H.293v1.631h1.631v1.63H.293v1.63h1.631V11.7H.32c.277 3.251 3.777 3.261 3.777 3.261h3.8a3.531 3.531 0 0 0 3.769-3.261Z"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M4.705 14.792v6.522" vectorEffect="non-scaling-stroke" />
            <path d="M7.295 14.792v6.522" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
      );
    case 'conference_rooms':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-597.449 -337.244)">
            <path d="M609.449 359.244h24" vectorEffect="non-scaling-stroke" />
            <path
              d="M612.115 359.244v5.369"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M630.782 359.244v5.369"
              vectorEffect="non-scaling-stroke"
            />
            <circle
              cx="4"
              cy="4"
              r="4"
              vectorEffect="non-scaling-stroke"
              transform="translate(617.449 347.244)"
            />
            <path
              d="M617.449 355.244s-4 0-4 4"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M625.449 355.244s4 0 4 4"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M606.915 373.959a3.964 3.964 0 0 1 7.928 0"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M617.485 373.959a3.964 3.964 0 0 1 7.928 0"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M612.2 368.674a3.964 3.964 0 1 1 7.928 0"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M622.77 368.674a3.964 3.964 0 0 1 7.928 0"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M628.055 373.959a3.964 3.964 0 1 1 7.928 0"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'standard_rate_m2':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M29.625 15.875h-7.5s-3.75 0-3.75 3.75 3.75 3.75 3.75 3.75h3.75s3.75 0 3.75 3.75-3.75 3.75-3.75 3.75h-7.5"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 14v18.75" vectorEffect="non-scaling-stroke" />
          <path d="M11.5 10.5h25v26h-25z" />
        </svg>
      );
    case 'largest_event':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M38.5 15.611v21.778a3.047 3.047 0 0 1-3.111 3.111H13.611a3.047 3.047 0 0 1-3.111-3.111V15.611a3.047 3.047 0 0 1 3.111-3.111h21.778a3.047 3.047 0 0 1 3.111 3.111Z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M19.333 12.222V6" vectorEffect="non-scaling-stroke" />
          <path d="M31.778 12.222V6" vectorEffect="non-scaling-stroke" />
          <path
            d="m24.91 19.73 2.08 3.368a.48.48 0 0 0 .3.215l3.846.938a.482.482 0 0 1 .253.78l-2.56 3.019a.481.481 0 0 0-.113.348l.3 3.947a.482.482 0 0 1-.664.482l-3.662-1.5a.479.479 0 0 0-.366 0l-3.663 1.5a.482.482 0 0 1-.664-.482l.3-3.947a.481.481 0 0 0-.113-.348l-2.56-3.019a.482.482 0 0 1 .253-.78l3.846-.938a.48.48 0 0 0 .3-.215l2.08-3.368a.482.482 0 0 1 .807 0Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'caterer_choice':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M18 15v3.7a2.527 2.527 0 0 0 2.58 2.58v12.39"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M23.16 15v3.7a2.527 2.527 0 0 1-2.58 2.58"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M20.58 21.277V15" vectorEffect="non-scaling-stroke" />
          <path
            d="M27.31 33.67V15.731c2.935 1.559 2.685 9.64 2.685 9.64H27.31"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M8 24.001a16 16 0 0 1 16-16"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M40 24.001a16 16 0 0 1-16 16"
            vectorEffect="non-scaling-stroke"
          />
          <path d="m24 4.001 4 4-4 4" vectorEffect="non-scaling-stroke" />
          <path d="m23.996 44.002-4-4 4-4" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'distance_city_centre':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(9 8.999)">
            <path
              vectorEffect="non-scaling-stroke"
              fill="#aebdc4"
              d="M17.508 14.673a2.834 2.834 0 1 1-2.835-2.835 2.835 2.835 0 0 1 2.835 2.835Z"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="8.504"
              cy="8.504"
              r="8.504"
              transform="translate(6.169 6.169)"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="14.173"
              cy="14.173"
              r="14.173"
              transform="translate(.5 .5)"
            />
          </g>
        </svg>
      );
    case 'health_measures':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(9 9.999)">
            <path
              vectorEffect="non-scaling-stroke"
              d="M23.177 11.839h-5.669V6.17h-5.67v5.669H6.169v5.669h5.669v5.67h5.67v-5.67h5.669Z"
            />
            <rect
              vectorEffect="non-scaling-stroke"
              width="28.346"
              height="28.346"
              rx="6.1"
              transform="translate(.5 .501)"
            />
          </g>
        </svg>
      );
    case 'iso_certification':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M23.088 32.539h-6.981a3.419 3.419 0 0 1-3.491-3.491V8.105a3.418 3.418 0 0 1 3.491-3.49h13.962a3.419 3.419 0 0 1 3.491 3.49v13.963"
          />
          <path vectorEffect="non-scaling-stroke" d="M16.106 11.597h13.963" />
          <path vectorEffect="non-scaling-stroke" d="M16.106 15.088h13.963" />
          <path vectorEffect="non-scaling-stroke" d="M16.106 18.578h13.963" />
          <path
            vectorEffect="non-scaling-stroke"
            d="M34.997 29.463a4.929 4.929 0 1 1-4.928-4.929 4.928 4.928 0 0 1 4.928 4.929Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="m26.857 33.198-1.718 8.586 4.93-4.928 4.928 4.928-1.728-8.624"
          />
        </svg>
      );
    case 'conference_rooms_count':
      return (
        <svg viewBox="0 0 48 48">
          <g strokeLinejoin="round">
            <path
              d="m25.273 23.727 5.09-5.095h-15.27L10 23.727Z"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M10 23.728h15.273v12.727H10z"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="m25.273 36.454 5.091-7.636V18.632"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M27.818 16.09v-1.7h6.788v6.788h-1.7"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M27.818 14.394 31.212 11H38l-3.395 3.394"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="m34.606 21.182 3.391-3.395V11"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'sustainability_policy':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M35.508 12.307s0 10.396-5.199 15.594-12.995 2.6-12.995 2.6-2.597-7.796 2.6-12.994 15.594-5.2 15.594-5.2Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M27.71 20.104 17.315 30.501s-5.198 5.198-7.797 2.598"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'theme_policy':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M12.666 11.778S24 11.778 24 8c0 3.778 11.334 3.778 11.334 3.778V26.89s0 7.555-11.334 11.334C12.666 34.446 12.666 26.89 12.666 26.89Z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 8v30.223" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'map':
    case 'venue-map':
    case 'plan':
    case 'floorplan':
    case 'venue-space-floorplan':
    case 'venueSpace-floorplan':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M19.667 10 11 16.905v20.711l8.667-6.9Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m37 10-8.667 6.9v20.716l8.667-6.9Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m19.668 10 8.665 6.905v20.711l-8.667-6.9Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    // case "":
    //   return (
    //     <svg viewBox="0 0 48 48">

    //     </svg>
    //   );
    case 'report':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            stroke="#aebdc4"
            d="M12 10v28.394"
          />
          <path
            fill="#aebdc4"
            stroke="none"
            style={{ stroke: 'none' }}
            d="M36 14.542a15.484 15.484 0 0 1-12.395-2.018c-6.2-4.038-9.3-2.019-9.3-2.019v16.151s3.1-2.018 9.3 2.019A15.484 15.484 0 0 0 36 30.693Z"
          />
        </svg>
      );
    /*
     *  More venue page icons
     */
    case 'document':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M12.002 12v24a2.938 2.938 0 0 0 3 3h18a2.938 2.938 0 0 0 3-3V15l-6-6h-15a2.938 2.938 0 0 0-3 3Z"
          />
          <path vectorEffect="non-scaling-stroke" d="M30 9v6h6" />
        </svg>
      );
    case 'video':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M15.5 13.203v20.748a1.7 1.7 0 0 0 2.6 1.442l16.6-10.374a1.7 1.7 0 0 0 0-2.884L18.1 11.761a1.7 1.7 0 0 0-2.6 1.442Z"
          />
        </svg>
      );
    case 'proposal':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-202.598 -276.464)">
            <path
              vectorEffect="non-scaling-stroke"
              d="M225.043 314.576h-9.333a3.047 3.047 0 0 1-3.111-3.111v-24.889a3.047 3.047 0 0 1 3.111-3.111h18.667a3.047 3.047 0 0 1 3.111 3.111v15.555"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M231.264 289.687H218.82"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M231.264 295.909H218.82"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M231.264 302.131H218.82"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="6.222"
              cy="6.222"
              r="6.222"
              transform="translate(228.154 305.242)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="m231.447 311.024 2.329 2.329 3.778-3.778"
            />
          </g>
        </svg>
      );
    case 'contact':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M32.4 31.6 26.8 26h-5.6V12H38v14h-5.6Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M26.8 28.8v2.8h-5.6l-5.6 5.6v-5.6H10v-14h8.4"
          />
        </svg>
      );
    case 'mail':
    case 'email':
    case 'inbox':
    case 'received':
    case 'createdat':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M8 18s0-4 4-4h24s4 0 4 4v12s0 4-4 4H12s-4 0-4-4Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M38.716 14.962 23.999 26 9.272 14.954"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="m28.571 22.571 10.316 10.316"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.429 22.571 9.113 32.887"
          />
        </svg>
      );
    case 'name':
    case 'firstname':
    case 'lastname':
    case 'family_name':
    case 'person':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-123.25 -214)">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="6.667"
              cy="6.667"
              r="6.667"
              transform="translate(140.583 225)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M137.25 248.703v-3.7s0-6.667 6.667-6.667h6.667s6.667 0 6.667 6.667v3.7"
            />
          </g>
        </svg>
      );
    case 'phone':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-198.749 -187)">
            <path
              vectorEffect="non-scaling-stroke"
              d="M214.749 201.2a3.134 3.134 0 0 1 3.2-3.2h9.6a3.134 3.134 0 0 1 3.2 3.2v19.2a3.134 3.134 0 0 1-3.2 3.2h-9.6a3.134 3.134 0 0 1-3.2-3.2Z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              d="M221.127 200.079h3.243"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="1.346"
              cy="1.346"
              r="1.346"
              transform="translate(221.403 218.965)"
              fill="#aebdc4"
            />
          </g>
        </svg>
      );
    case 'laptop':
      return (
        <svg viewBox="0 0 48 48">
          <path vectorEffect="non-scaling-stroke" d="M8 32.999h32.4" />
          <path vectorEffect="non-scaling-stroke" d="M37.566 33V15H10.834v18" />
          <path
            vectorEffect="non-scaling-stroke"
            d="M24.836 17.039a.635.635 0 1 1-.635-.635.635.635 0 0 1 .635.635"
            fill="#aebdc4"
          />
        </svg>
      );
    case 'conference_largest_room_pax':
      return (
        <svg viewBox="0 0 48 48">
          <circle
            cx="4"
            cy="4"
            r="4"
            vectorEffect="non-scaling-stroke"
            transform="translate(20 15)"
          />
          <path
            d="M20 23s-4 0-4 4v4h16v-4s0-4-4-4"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M9.833 19.277V9.833h9.444"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M28.723 9.833h9.444v9.444"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M38.167 28.723v9.444h-9.444"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M19.277 38.167H9.833v-9.444"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'conference_largest_room_sqm':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M9.833 19.277V9.833h9.444"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M28.723 9.833h9.444v9.444"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M38.167 28.723v9.444h-9.444"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M19.277 38.167H9.833v-9.444"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    /**
     * Halls
     */
    case 'floors':
    case 'level':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="m7.999 23.667 10.666-10.666h21.334L29.333 23.667Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M34.666 18.335H40L29.332 29H8l5.332-5.331"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M34.666 23.668H40L29.332 34.334H8l5.332-5.335"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'divisable':
    case 'partition_walls':
    case 'partition_max_rooms':
      return (
        <svg viewBox="0 0 48 48">
          <path d="M12 16h8v8h-8z" vectorEffect="non-scaling-stroke" />
          <path d="M28 12h8v8h-8z" vectorEffect="non-scaling-stroke" />
          <path d="M12 28h8v8h-8z" vectorEffect="non-scaling-stroke" />
          <path d="M24 28h8v8h-8z" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'electricity':
    case 'electric_capacity':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M14.5 27.166h10v10l10-16.666h-10v-10Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'water':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(16 9.579)">
            <path
              d="M9 1.652 2.274 11.741a8.082 8.082 0 1 0 13.45 0Z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'air_conditioning':
      return (
        <svg viewBox="0 0 48 48">
          <path d="M24 12.334V39" vectorEffect="non-scaling-stroke" />
          <path d="M24 9v30" vectorEffect="non-scaling-stroke" />
          <path
            d="M20.165 10.835 24 14.67l3.834-3.835"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m28.509 36.843-4.51-4.51-4.508 4.51"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M28.771 19.228 12.736 35.263"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M35.264 12.736 12.736 35.264"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M31.255 11.322v5.423h5.423"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M16.745 36.678v-5.423h-5.423"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M35.666 24H9" vectorEffect="non-scaling-stroke" />
          <path d="M39 24H9" vectorEffect="non-scaling-stroke" />
          <path
            d="M37.165 20.165 33.33 24l3.835 3.834"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m11.158 28.509 4.51-4.51-4.51-4.508"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M28.771 28.771 12.736 12.736"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M35.264 35.264 12.736 12.736"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M36.678 31.255h-5.423v5.423"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M11.322 16.745h5.423v-5.423"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'columns':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M17.586 21.983c0 1.324-2.146 2.4-4.793 2.4S8 23.307 8 21.983s2.147-2.4 4.794-2.4 4.792 1.076 4.792 2.4Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M17.586 36.363c0 1.324-2.146 2.4-4.793 2.4S8 37.682 8 36.363"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M8 21.983v14.379" vectorEffect="non-scaling-stroke" />
          <path d="M17.586 21.983v14.379" vectorEffect="non-scaling-stroke" />
          <path
            d="M31.965 21.983c0 1.324-2.146 2.4-4.794 2.4s-4.794-1.073-4.794-2.4 2.147-2.4 4.794-2.4 4.794 1.076 4.794 2.4Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M31.965 36.363c0 1.324-2.146 2.4-4.794 2.4s-4.794-1.073-4.794-2.4"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M22.379 21.983v14.379" vectorEffect="non-scaling-stroke" />
          <path d="M31.965 21.983v14.379" vectorEffect="non-scaling-stroke" />
          <path
            d="M24.775 12.401c0 1.324-2.146 2.4-4.793 2.4s-4.797-1.079-4.797-2.4 2.151-2.4 4.8-2.4 4.79 1.073 4.79 2.4Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M22.379 28.855a9.121 9.121 0 0 1-4.793 0"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M15.189 12.397v7.19" vectorEffect="non-scaling-stroke" />
          <path d="M24.775 12.397v7.19" vectorEffect="non-scaling-stroke" />
          <path
            d="M39.157 12.401c0 1.324-2.146 2.4-4.793 2.4s-4.794-1.073-4.794-2.4 2.145-2.4 4.787-2.4 4.8 1.073 4.8 2.4Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M39.155 26.776c0 1.324-2.146 2.4-4.793 2.4a8.685 8.685 0 0 1-2.4-.321"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M29.568 12.397v7.19" vectorEffect="non-scaling-stroke" />
          <path d="M39.155 12.397v14.379" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'installation_grid':
    case 'installation_grid_size':
    case 'installation_grid_m2':
    case 'rigging_grid':
    case 'rigging_capacity':
    case 'rigging_capcity':
    case 'riggings':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M9.634 9.634h7.183v28.733H9.634z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M9.634 16.816h7.183" vectorEffect="non-scaling-stroke" />
          <path d="M9.634 24h7.183" vectorEffect="non-scaling-stroke" />
          <path d="M9.634 31.184h7.183" vectorEffect="non-scaling-stroke" />
          <path
            d="m9.634 9.634 7.183 7.183"
            vectorEffect="non-scaling-stroke"
          />
          <path d="m9.634 24 7.183-7.183" vectorEffect="non-scaling-stroke" />
          <path
            d="m9.634 38.367 7.183-7.183"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M16.817 31.183 9.634 24" vectorEffect="non-scaling-stroke" />
          <path
            d="M31.184 9.634h7.183v28.733h-7.183z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M31.183 16.816h7.183" vectorEffect="non-scaling-stroke" />
          <path d="M31.183 24h7.183" vectorEffect="non-scaling-stroke" />
          <path d="M31.183 31.184h7.183" vectorEffect="non-scaling-stroke" />
          <path
            d="m31.183 9.634 7.183 7.183"
            vectorEffect="non-scaling-stroke"
          />
          <path d="m31.183 24 7.183-7.183" vectorEffect="non-scaling-stroke" />
          <path
            d="m31.183 38.367 7.183-7.183"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M38.367 31.183 31.184 24"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M16.816 9.634h14.367v7.183H16.816z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 9.634v7.183" vectorEffect="non-scaling-stroke" />
          <path d="M31.183 9.634 24 16.817" vectorEffect="non-scaling-stroke" />
          <path d="M16.817 9.634 24 16.817" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'gates':
    case 'gates_width':
    case 'gates_height':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M42.325 35.652V20.334s0-7.658-7.659-7.658-7.659 7.658-7.659 7.658v15.318Z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M34.666 12.676v22.976" vectorEffect="non-scaling-stroke" />
          <path
            d="m15.519 31.822-7.658 3.83V20.334s0-7.658 7.658-7.658Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            fill="#aebdc4"
            d="M15.519 12.676v19.146l-7.658 3.83h15.316V20.334s0-7.658-7.658-7.658"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'pressurised_air':
    case 'air_outlet':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M33.594 15.169a4.209 4.209 0 0 0-1.776.4 8.5 8.5 0 0 0-14.759-2.9 5.67 5.67 0 1 0 0 10.679 8.491 8.491 0 0 0 13.753-.73 4.245 4.245 0 1 0 2.782-7.444Z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M23.673 29.343v8.504" vectorEffect="non-scaling-stroke" />
          <path
            d="M20.839 37.847 15.17 26.508"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m26.508 37.847 5.669-11.339"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'loading_elevators':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M37.409 37.41H10.591V10.592h26.818Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M30.704 37.409V20.644H17.295v16.765"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 20.648v16.761" vectorEffect="non-scaling-stroke" />
          <path
            fill="#aebdc4"
            d="m17.05 17.133 3.38-3.238 3.377 3.238Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            fill="#aebdc4"
            d="m30.504 13.895-3.383 3.238-3.378-3.238Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'loading_ramps':
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="#aebdc4"
            d="M13.105 13.783h7.106v7.106"
            vectorEffect="non-scaling-stroke"
          />
          <path
            stroke="#aebdc4"
            d="M9.553 24.44 20.21 13.783"
            vectorEffect="non-scaling-stroke"
          />
          <path
            stroke="#aebdc4"
            d="m11.609 35.18 17.739-17.74h8.869v17.74Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'load_factor_kg_m2':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="m16.091 20.753-4.15 10.38c-.98 2.448.444 5.326 2.633 5.326h18.852c2.189 0 3.613-2.878 2.634-5.326l-4.151-10.38a2.954 2.954 0 0 0-2.633-2.031h-10.55a2.956 2.956 0 0 0-2.635 2.031Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M20.453 15.175A3.547 3.547 0 1 1 24 18.727a3.548 3.548 0 0 1-3.547-3.552Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'fixed_seating':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M15.111 25.333h17.778v2.223H15.111z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M17.333 25.333v-11.11A2.177 2.177 0 0 1 19.556 12h8.888a2.177 2.177 0 0 1 2.222 2.223v11.11"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 27.555v8.889" vectorEffect="non-scaling-stroke" />
          <path d="M17.333 36.444h13.333" vectorEffect="non-scaling-stroke" />
          <path d="M4 20.888h11.111" vectorEffect="non-scaling-stroke" />
          <path
            d="m10.663 25.333 4.444-4.444-4.444-4.445"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M44 20.888H32.889" vectorEffect="non-scaling-stroke" />
          <path
            d="m37.333 16.444-4.444 4.444 4.444 4.445"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'removable_seating':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M23.536 28.437H13.001v-2.634h10.535"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M15.635 25.8V12.634A2.58 2.58 0 0 1 18.269 10h5.267"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M23.536 28.436v10.536" vectorEffect="non-scaling-stroke" />
          <path d="M15.634 38.973h7.902" vectorEffect="non-scaling-stroke" />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#aebdc4"
            d="M34.571 28.937h-1.035v-1h.536v.036h.5Zm-2.036 0h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Zm10.036-1.964h-1v-1h1Zm-1.33-.67h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#aebdc4"
            d="M31.938 25.8h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Zm-1.114-1.842a2.285 2.285 0 0 0-.358-.734l.8-.6a3.279 3.279 0 0 1 .518 1.053Zm-.944-1.229a2.155 2.155 0 0 0-.778-.215l.1-1a3.147 3.147 0 0 1 1.137.32Zm-1.729-.229h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-.615v-1h.615Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#aebdc4"
            d="M31.436 39.473h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Zm-2 0h-1v-1h1Z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'seating':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M12.5 25.507h22.677v2.835H12.5z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M15.335 25.508V11.335A2.777 2.777 0 0 1 18.17 8.5h11.338a2.777 2.777 0 0 1 2.835 2.835v14.173"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M23.839 28.343v11.339" vectorEffect="non-scaling-stroke" />
          <path d="M15.335 39.682h17.008" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'capacity_per_type1':
    case 'pax_type_1': // frontal
      return (
        <svg viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="M8.115 15.886a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M13.944 15.886a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.771 15.886a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M8.115 12a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M13.944 12a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.771 12a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M8.115 19.771a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M13.944 19.771a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.771 19.771a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M4.228 2.285h15.543v1.943H4.228z"
          />
        </svg>
      );
    case 'capacity_per_type2':
    case 'pax_type_2': // frontal table
      return (
        <svg viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="M10.834 19.495a2.334 2.334 0 0 1-4.663 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.829 19.495a2.334 2.334 0 0 1-4.663 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M4.228 2.286h15.543v1.943H4.228z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M5.171 16.053h5.663v1.221H5.171z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M13.166 16.053h5.663v1.221h-5.663z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M10.834 11.61a2.334 2.334 0 0 1-4.663 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.829 11.61a2.334 2.334 0 0 1-4.663 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M5.171 8.169h5.663V9.39H5.171z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M13.166 8.169h5.663V9.39h-5.663z"
          />
        </svg>
      );
    case 'capacity_per_type3':
    case 'pax_type_3': // long table
      return (
        <svg viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="M8.114 4.229h7.772v15.543H8.114z"
            data-name="Rechteck 191"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M6.171 8.116a1.943 1.943 0 1 1 0-3.886Z"
            data-name="Pfad 189"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M6.171 13.944a1.943 1.943 0 1 1 0-3.886Z"
            data-name="Pfad 190"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M6.171 19.772a1.943 1.943 0 1 1 0-3.886Z"
            data-name="Pfad 191"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.829 15.886a1.943 1.943 0 1 1 0 3.886Z"
            data-name="Pfad 192"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.829 10.057a1.943 1.943 0 1 1 0 3.886Z"
            data-name="Pfad 193"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M17.829 4.229a1.943 1.943 0 1 1 0 3.886Z"
            data-name="Pfad 194"
          />
        </svg>
      );
    case 'capacity_per_type4':
    case 'pax_type_4': // horseshoe
      return (
        <svg viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="M4.228 2.286h15.543v1.943H4.228z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M11.029 19.772a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M16.857 19.772a1.943 1.943 0 1 1-3.886 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M5.205 12a1.943 1.943 0 1 1 0-3.886Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M5.205 17.83a1.943 1.943 0 1 1 0-3.886Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M18.8 13.944a1.943 1.943 0 1 1 0 3.886Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M18.8 8.114a1.943 1.943 0 1 1 0 3.886Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M7.142 8.114v9.714h9.714V8.114h-1.942v7.771H9.085V8.114Z"
          />
        </svg>
      );
    case 'capacity_per_type5':
    case 'pax_type_5': // groups
      return (
        <svg viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="M16.792 14.397a1.37 1.37 0 0 1 2.739 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M19.531 19.873a1.37 1.37 0 0 1-2.739 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M15.422 18.504a1.37 1.37 0 1 1 0-2.739Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M20.899 15.761a1.37 1.37 0 1 1 0 2.739Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M16.792 17.134a1.369 1.369 0 1 1 1.369 1.369 1.369 1.369 0 0 1-1.369-1.369"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M10.631 4.127a1.37 1.37 0 0 1 2.739 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M13.37 9.602a1.37 1.37 0 0 1-2.739 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M9.261 8.235a1.37 1.37 0 1 1 0-2.739Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M14.738 5.496a1.37 1.37 0 1 1 0 2.739Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M10.631 6.865A1.369 1.369 0 1 1 12 8.234a1.369 1.369 0 0 1-1.369-1.369"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M4.469 14.397a1.37 1.37 0 0 1 2.739 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M7.208 19.873a1.37 1.37 0 0 1-2.739 0Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M3.097 18.504a1.37 1.37 0 1 1 0-2.739Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M8.577 15.761a1.37 1.37 0 1 1 0 2.739Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M4.469 17.134a1.369 1.369 0 1 1 1.369 1.369 1.369 1.369 0 0 1-1.369-1.369"
          />
        </svg>
      );
    case 'capacity_per_type6':
    case 'pax_type_6': // party
      return (
        <svg viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="m17.828 6.167-5.829 7.772-5.832-7.772Z"
          />
          <path vectorEffect="non-scaling-stroke" d="M12 13.5v4.329" />
          <path vectorEffect="non-scaling-stroke" d="M15.886 17.828H8.114" />
          <path vectorEffect="non-scaling-stroke" d="M8.5 6.171 6.172 1.956" />
        </svg>
      );
    case 'natural_lighting':
    case 'natural_light':
    case 'natural_light_blocking':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M30.396 23.996a6.4 6.4 0 1 1-6.4-6.4 6.4 6.4 0 0 1 6.4 6.4Z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 14.399v-6.4" vectorEffect="non-scaling-stroke" />
          <path d="M24 40v-6.4" vectorEffect="non-scaling-stroke" />
          <path
            d="m30.789 17.212 4.526-4.526"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m12.686 35.313 4.526-4.526"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M33.6 23.999H40" vectorEffect="non-scaling-stroke" />
          <path d="M8 23.999h6.4" vectorEffect="non-scaling-stroke" />
          <path
            d="m30.789 30.787 4.526 4.526"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="m12.686 12.686 4.526 4.526"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'translator_booth':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M14.902 34.549v-4.55h-5.43a3.671 3.671 0 0 1-3.67-3.67v-6.306a3.672 3.672 0 0 1 3.67-3.672h15.4a3.672 3.672 0 0 1 3.672 3.672v6.306a3.671 3.671 0 0 1-3.672 3.67H19.45Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M24.001 11.802h14.526a3.672 3.672 0 0 1 3.672 3.672v6.3a3.672 3.672 0 0 1-3.672 3.672h-.878v4.556l-4.55-4.55"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'av_system':
    case 'builtin_av':
      return (
        <svg viewBox="0 0 48 48">
          <path d="M9 11h30v25.715H9z" vectorEffect="non-scaling-stroke" />
          <path
            d="M13.286 15.286h4.285v4.285h-4.285z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M21.857 15.286h4.285v4.285h-4.285z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M13.286 23.857h4.285v4.285h-4.285z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M21.857 23.857h4.285v4.285h-4.285z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M32.571 15.285v2.143" vectorEffect="non-scaling-stroke" />
          <path d="M32.571 19.572v12.857" vectorEffect="non-scaling-stroke" />
          <path
            d="M30.429 17.428h4.285v2.143h-4.285z"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'dimming':
    case 'lighting':
    case 'light_dimming_adjustment':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(13 8)">
            <path
              d="M5.805 19.617v6.967s0 5.195 5.195 5.195 5.195-5.195 5.195-5.195v-6.768"
              vectorEffect="non-scaling-stroke"
            />
            <circle
              cx="10.389"
              cy="10.389"
              r="10.389"
              vectorEffect="non-scaling-stroke"
              transform="translate(.611 .611)"
            />
            <path
              d="m6.05 26.046 10.389-3.463"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="m6.05 29.76 10.389-3.463"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M7.538 20.298v-5.956l1.73-1.871 1.731 1.872 1.731-1.872 1.731 1.872v5.956"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'podium':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-600.449 -338.244)">
            <path d="M609.449 367.244h30" vectorEffect="non-scaling-stroke" />
            <path d="M612.782 367.244v11" vectorEffect="non-scaling-stroke" />
            <path d="M636.115 367.244v11" vectorEffect="non-scaling-stroke" />
            <circle
              cx="5"
              cy="5"
              r="5"
              vectorEffect="non-scaling-stroke"
              transform="translate(619.449 347.244)"
            />
            <path
              d="M619.449 357.244s-5 0-5 5v5"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M629.449 357.244s5 0 5 5v5"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
    case 'screen_projection':
    case 'screen_projector':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M15.185 37.223 24 32.815l8.816 4.408"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M24 32.814v-4.408" vectorEffect="non-scaling-stroke" />
          <path
            d="M10.777 10.775h26.445v17.631H10.777z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M10.777 15.185h26.445" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'f_b_outlet':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M16 11.999v4.929a3.37 3.37 0 0 0 3.441 3.44v16.525"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M22.881 11.999v4.929a3.37 3.37 0 0 1-3.441 3.44"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M19.44 20.368v-8.369" vectorEffect="non-scaling-stroke" />
          <path
            d="M28.413 36.892V12.974c3.914 2.078 3.58 12.854 3.58 12.854h-3.58"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      );
    case 'flooring':
    case 'flooring_material':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M3.829 27.839 20.837 16.5h25.512L29.341 27.839Z"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M29.341 16.5 12.333 27.839"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M37.845 16.5 20.837 27.839"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M15.168 20.28H40.68" vectorEffect="non-scaling-stroke" />
          <path d="M9.499 24.059h25.512" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'promotion':
    case 'description':
    case 'tax_id':
    case 'billing_account':
      return (
        <svg viewBox="0 0 48 48">
          <path
            d="M13.891 10.892h20.217v25.27H13.891z"
            vectorEffect="non-scaling-stroke"
          />
          <path d="M18.945 15.945h10.108" vectorEffect="non-scaling-stroke" />
          <path d="M18.945 21h10.108" vectorEffect="non-scaling-stroke" />
          <path d="M18.945 26.054h10.108" vectorEffect="non-scaling-stroke" />
        </svg>
      );
    case 'categories':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(-2.433 -2.434)">
            <path
              d="M32.857 26.557v-2.824H29.92a9.829 9.829 0 0 0-1.865-4.5l2.078-2.078-2-2-2.075 2.078a9.822 9.822 0 0 0-4.5-1.865v-2.935h-2.825v2.937a9.814 9.814 0 0 0-4.5 1.863l-2.077-2.075-2 2 2.077 2.075a9.829 9.829 0 0 0-1.865 4.5H7.433v2.825h2.937a9.825 9.825 0 0 0 1.865 4.5l-2.077 2.075 2 2 2.075-2.078a9.823 9.823 0 0 0 4.5 1.864v2.938h2.824v-2.938a9.831 9.831 0 0 0 4.5-1.864l2.076 2.078 2-2-2.077-2.077a9.825 9.825 0 0 0 1.865-4.5Z"
              vectorEffect="non-scaling-stroke"
            />
            <circle
              cx="4.237"
              cy="4.237"
              r="4.237"
              vectorEffect="non-scaling-stroke"
              transform="translate(15.907 20.907)"
            />
            <path
              stroke="none"
              style={{ stroke: 'none' }}
              fill="#aebdc4"
              d="m44.695 36.307.638-1.435-1.492-.663a5.452 5.452 0 0 0 .069-2.708l1.524-.586-.563-1.465-1.522.586a5.458 5.458 0 0 0-1.866-1.963l.663-1.492-1.435-.638-.662 1.492a5.449 5.449 0 0 0-2.707-.069l-.593-1.523-1.466.563.586 1.524a5.474 5.474 0 0 0-1.963 1.866l-1.492-.663-.638 1.435 1.492.663a5.46 5.46 0 0 0-.069 2.707l-1.524.586.574 1.462 1.524-.586a5.463 5.463 0 0 0 1.865 1.963l-.663 1.492 1.435.638.663-1.492a5.472 5.472 0 0 0 2.707.069l.587 1.524 1.465-.564-.586-1.524a5.447 5.447 0 0 0 1.963-1.865Z"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="none"
              style={{ stroke: 'none' }}
              fill="#fff"
              d="M40.708 33.675a2.356 2.356 0 1 1-1.2-3.109 2.356 2.356 0 0 1 1.2 3.109Z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
          {/* <g transform="translate(-2.433 -2.433)">
            <path stroke="none" style={{stroke: "none"}}  fill="#aebdc4" d="M32.857 26.557v-2.824H29.92a9.829 9.829 0 0 0-1.865-4.5l2.078-2.078-2-2-2.075 2.078a9.822 9.822 0 0 0-4.5-1.865v-2.935h-2.825v2.937a9.814 9.814 0 0 0-4.5 1.863l-2.077-2.075-2 2 2.077 2.075a9.829 9.829 0 0 0-1.865 4.5H7.433v2.825h2.937a9.825 9.825 0 0 0 1.865 4.5l-2.077 2.075 2 2 2.075-2.078a9.823 9.823 0 0 0 4.5 1.864v2.938h2.824v-2.938a9.831 9.831 0 0 0 4.5-1.864l2.076 2.078 2-2-2.077-2.077a9.825 9.825 0 0 0 1.865-4.5Z" />
            <circle stroke="none" style={{stroke: "none"}}  cx="4.237" cy="4.237" r="4.237" fill="#fff" transform="translate(15.907 20.907)"/>
            <path d="m44.695 36.307.638-1.435-1.492-.663a5.452 5.452 0 0 0 .069-2.708l1.524-.586-.563-1.465-1.522.586a5.458 5.458 0 0 0-1.866-1.963l.663-1.492-1.435-.638-.662 1.492a5.449 5.449 0 0 0-2.707-.069l-.593-1.523-1.466.563.586 1.524a5.474 5.474 0 0 0-1.963 1.866l-1.492-.663-.638 1.435 1.492.663a5.46 5.46 0 0 0-.069 2.707l-1.524.586.574 1.462 1.524-.586a5.463 5.463 0 0 0 1.865 1.963l-.663 1.492 1.435.638.663-1.492a5.472 5.472 0 0 0 2.707.069l.587 1.524 1.465-.564-.586-1.524a5.447 5.447 0 0 0 1.963-1.865Z" />
            <path d="M40.708 33.675a2.356 2.356 0 1 1-1.2-3.109 2.356 2.356 0 0 1 1.2 3.109Z" vectorEffect="non-scaling-stroke"/>
          </g> */}
        </svg>
      );
    case 'circle':
      return (
        <svg viewBox="0 0 48 48">
          <circle
            cx="24"
            cy="24"
            r="20"
            strokeWidth="2"
            vectorEffect="non-scaling-stroke"
          ></circle>
        </svg>
      );
    case 'help':
      return (
        <svg viewBox="0 0 1024 1024">
          <g transform="scale(.8) translate(100, 100)">
            <path
              vectorEffect="non-scaling-stroke"
              stroke="none"
              style={{ stroke: 'none' }}
              fill="#001640"
              d="M512 993.882353C245.850353 993.882353 30.117647 778.149647 30.117647 512S245.850353 30.117647 512 30.117647s481.882353 215.732706 481.882353 481.882353-215.732706 481.882353-481.882353 481.882353z m0-60.235294c232.869647 0 421.647059-188.777412 421.647059-421.647059S744.869647 90.352941 512 90.352941 90.352941 279.130353 90.352941 512s188.777412 421.647059 421.647059 421.647059z"
            />
            <path
              vectorEffect="non-scaling-stroke"
              stroke="none"
              fill="#001640"
              style={{ stroke: 'none' }}
              d="M510.132706 778.511059a43.760941 43.760941 0 1 1 0-87.521883 43.760941 43.760941 0 0 1 0 87.521883zM391.830588 433.814588a30.659765 30.659765 0 0 1-30.208-34.42447c1.987765-17.016471 5.150118-30.930824 9.487059-41.743059a124.325647 124.325647 0 0 1 33.400471-46.592 148.961882 148.961882 0 0 1 51.109647-30.238118A180.615529 180.615529 0 0 1 515.132235 271.058824c42.164706 0 77.251765 12.408471 105.321412 37.255529 28.069647 24.756706 42.134588 57.825882 42.134588 99.087059 0 18.552471-3.614118 35.358118-10.842353 50.416941-7.168 15.088941-22.467765 33.882353-45.869176 56.350118-23.461647 22.497882-38.942118 38.490353-46.622118 48.007529a98.243765 98.243765 0 0 0-17.347764 34.063059c-2.108235 6.957176-3.614118 15.179294-4.427295 24.636235-1.445647 15.962353-14.275765 28.611765-30.298353 28.611765a30.659765 30.659765 0 0 1-30.32847-33.641412c1.054118-10.962824 2.650353-20.510118 4.879059-28.641882 4.126118-15.510588 10.390588-29.063529 18.763294-40.658824 8.342588-11.625412 23.401412-28.672 45.17647-51.169882 21.805176-22.467765 35.84-38.851765 42.164706-49.001412 6.204235-10.209882 12.739765-26.804706 12.739765-46.983529s-10.631529-36.592941-24.937412-52.133647c-14.396235-15.540706-35.267765-23.341176-62.644706-23.341177-53.428706 0-83.727059 27.497412-90.834823 82.492235-2.017882 15.480471-14.607059 27.407059-30.208 27.407059h-0.120471z"
            />
          </g>
        </svg>
      );
    /**
     * Partner
     * */
    case 'tsnn':
      return (
        <svg viewBox="0 0 208.933 70.52">
          <defs>
            <linearGradient
              id="tsnn-b"
              x1="0"
              x2="1"
              y1="0"
              y2="0"
              gradientTransform="matrix(0 112.432 112.432 0 133.911 0)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset=".19" stopColor="#fff" />
              <stop offset=".218" stopColor="#fff" />
              <stop offset=".571" stopColor="#fff" />
              <stop offset="1" stopColor="#fff" />
            </linearGradient>
            <linearGradient
              id="tsnn-d"
              x1="0"
              x2="1"
              y1="0"
              y2="0"
              gradientTransform="matrix(0 120.469 120.469 0 424.766 0)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset=".19" stopColor="#fff" />
              <stop offset=".218" stopColor="#fff" />
              <stop offset=".571" stopColor="#fff" />
              <stop offset="1" stopColor="#fff" />
            </linearGradient>
            <linearGradient
              id="tsnn-f"
              x1="0"
              x2="1"
              y1="0"
              y2="0"
              gradientTransform="matrix(0 112.432 112.432 0 748.154 0)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset=".19" stopColor="#fff" />
              <stop offset=".218" stopColor="#fff" />
              <stop offset=".571" stopColor="#fff" />
              <stop offset="1" stopColor="#fff" />
            </linearGradient>
            <linearGradient
              id="tsnn-h"
              x1="0"
              x2="1"
              y1="0"
              y2="0"
              gradientTransform="matrix(0 112.432 112.432 0 1087.45 0)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset=".19" stopColor="#fff" />
              <stop offset=".218" stopColor="#fff" />
              <stop offset=".571" stopColor="#fff" />
              <stop offset="1" stopColor="#fff" />
            </linearGradient>
            <linearGradient
              id="tsnn-j"
              x1="0"
              x2="1"
              y1="0"
              y2="0"
              gradientTransform="matrix(0 120.469 120.469 0 424.766 0)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset=".19" stopColor="#fff" />
              <stop offset=".218" stopColor="#fff" />
              <stop offset=".571" stopColor="#fff" />
              <stop offset="1" stopColor="#fff" />
            </linearGradient>
            <clipPath id="tsnn-a" clipPathUnits="userSpaceOnUse">
              <path d="M181.977 0h-.477v112.43H85.848h96.129V0" />
            </clipPath>
            <clipPath id="tsnn-c" clipPathUnits="userSpaceOnUse">
              <path d="M561.719 0h-.485c-3.429 85.71-54.246 120.406-139.179 120.469h.246c85.07 0 135.984-34.668 139.418-120.469" />
            </clipPath>
            <clipPath id="tsnn-e" clipPathUnits="userSpaceOnUse">
              <path d="M888.066 0h-.468v112.43H779.324h108.742V0M694.07 0h-.472v112.43h-85.36 85.832V0" />
            </clipPath>
            <clipPath id="tsnn-g" clipPathUnits="userSpaceOnUse">
              <path d="M1227.35 0h-.48v112.43h-108.25 108.73V0m-193.97 0h-.49v112.43h-85.339 85.829V0" />
            </clipPath>
            <clipPath id="tsnn-i" clipPathUnits="userSpaceOnUse">
              <path d="M380.227 0h-.192v1.992c0 30.918 8.598 54.375 41.789 54.375h.242C389.07 56.247 380.227 30.844 380.227 0" />
            </clipPath>
          </defs>
          <g stroke="none">
            <g
              clipPath="url(#tsnn-a)"
              transform="matrix(.13333 0 0 -.13333 0 70.52)"
            >
              <path
                fill="url(#tsnn-b)"
                d="M181.977 0h-.477v112.43H85.848h96.129V0"
              />
            </g>
            <g
              clipPath="url(#tsnn-c)"
              transform="matrix(.13333 0 0 -.13333 0 70.52)"
            >
              <path
                fill="url(#tsnn-d)"
                d="M561.719 0h-.485c-3.429 85.71-54.246 120.406-139.179 120.469h.246c85.07 0 135.984-34.668 139.418-120.469"
              />
            </g>
            <g
              clipPath="url(#tsnn-e)"
              transform="matrix(.13333 0 0 -.13333 0 70.52)"
            >
              <path
                fill="url(#tsnn-f)"
                d="M888.066 0h-.468v112.43H779.324h108.742V0M694.07 0h-.472v112.43h-85.36 85.832V0"
              />
            </g>
            <g
              clipPath="url(#tsnn-g)"
              transform="matrix(.13333 0 0 -.13333 0 70.52)"
            >
              <path
                fill="url(#tsnn-h)"
                d="M1227.35 0h-.48v112.43h-108.25 108.73V0m-193.97 0h-.49v112.43h-85.339 85.829V0"
              />
            </g>
            <g
              clipPath="url(#tsnn-i)"
              transform="matrix(.13333 0 0 -.13333 0 70.52)"
            >
              <path
                fill="url(#tsnn-j)"
                d="M380.227 0h-.192v1.992c0 30.918 8.598 54.375 41.789 54.375h.242C389.07 56.247 380.227 30.844 380.227 0"
              />
            </g>
            <path
              fill="#f36917"
              d="M11.446 11.445H0V1.066h35.706v10.379H24.264v44.093H11.446V11.445m39.289 27.463v1.906c0 4.121 1.146 7.25 5.572 7.25 4.5 0 5.798-3.354 5.798-6.485 0-11.75-23.421-5.187-23.421-25.557 0-8.698 4.65-16.023 17.851-16.023 12.816 0 17.395 6.486 17.395 14.88v1.294H61.57c0-2.593-.304-4.5-1.068-5.721-.762-1.298-1.986-1.906-3.894-1.906-3.2 0-5.107 1.906-5.107 5.873 0 11.367 23.419 5.647 23.419 24.87 0 12.362-6.863 17.32-18.613 17.32-9.31 0-17.932-2.82-17.932-14.19v-3.511h12.36M81.098 1.066h14.724l10.533 35.402h.15V1.066h11.904v54.472h-14.5L92.697 18.005h-.153v37.533H81.098V1.066m45.242 0h14.724l10.527 35.402h.157V1.066h11.899v54.472h-14.498l-11.213-37.533h-.152v37.533H126.34V1.066"
            />
            <path
              fill="#1476c6"
              d="M169.707 2.512h-2.176V1.124h5.772v1.388h-2.139v8.936h-1.457V2.512m3.388 1.158h1.382v1.214h.026c.154-.434.36-.78.622-1.034.258-.255.584-.383.976-.383.16 0 .272.02.335.058v1.59l-.24-.058-.336-.029c-.153 0-.316.025-.48.073a1.062 1.062 0 0 0-.45.268c-.131.13-.237.31-.326.541-.085.232-.127.526-.127.882v4.656h-1.382V3.67m7.164 3.672c-.095.077-.21.146-.339.21-.133.062-.27.123-.408.18-.143.057-.281.113-.424.166a2.702 2.702 0 0 0-.365.166.957.957 0 0 0-.43.494c-.088.22-.13.476-.13.766 0 .326.068.603.208.83.144.227.356.34.648.34.417 0 .726-.165.932-.493.205-.326.308-.779.308-1.359zm1.304 2.487a.71.71 0 0 0 .102.383l.255.167.233-.044v1.013l-.301.128a1.208 1.208 0 0 1-.38.059c-.307 0-.572-.077-.797-.231-.227-.156-.348-.42-.367-.797h-.024c-.19.386-.417.674-.69.861-.273.19-.614.284-1.022.284-.567 0-1.005-.177-1.32-.529-.315-.35-.472-.903-.472-1.656 0-.433.039-.788.12-1.064.081-.274.193-.5.332-.677.141-.178.31-.32.507-.42.196-.102.409-.196.64-.282l1.073-.333c.247-.077.445-.177.588-.302.147-.127.219-.359.219-.695 0-.357-.066-.638-.2-.846-.132-.208-.383-.312-.748-.312-.228 0-.412.044-.551.13a.979.979 0 0 0-.317.333c-.08.136-.128.294-.15.477a4.84 4.84 0 0 0-.03.55h-1.306c0-.414.04-.78.126-1.1.077-.317.213-.585.4-.801.188-.218.434-.381.748-.493.312-.11.692-.165 1.142-.165.31 0 .595.036.859.11.265.07.496.182.692.33.196.15.353.345.465.586.116.24.174.535.174.883v4.453m4.925-2.184a15 15 0 0 0-.047-1.243 3.785 3.785 0 0 0-.176-.926 1.25 1.25 0 0 0-.385-.571c-.17-.13-.383-.194-.647-.194a.833.833 0 0 0-.497.144c-.137.095-.247.256-.333.478-.087.22-.147.512-.187.873-.037.362-.056.803-.056 1.323 0 .444.015.842.045 1.193.03.353.084.653.17.904.088.252.206.443.353.579.15.134.347.202.593.202a.868.868 0 0 0 .587-.195 1.33 1.33 0 0 0 .35-.557c.086-.24.146-.529.175-.867.038-.338.055-.719.055-1.143zm0 2.849h-.027c-.044.125-.1.255-.173.39-.07.136-.164.26-.28.376-.115.118-.26.21-.433.283-.176.07-.382.109-.62.109-.803 0-1.38-.368-1.73-1.1-.349-.733-.524-1.764-.524-3.095 0-.867.062-1.562.186-2.081.125-.52.285-.924.486-1.208.2-.283.427-.472.676-.563.254-.092.511-.138.774-.138.386 0 .708.099.974.296.262.198.46.47.588.817h.026V1.124h1.381v10.324h-1.304v-.954m6.037-3.803v-.42c0-.491-.08-.902-.236-1.235-.158-.333-.433-.5-.825-.5a.89.89 0 0 0-.55.167c-.147.11-.266.261-.354.448a2.518 2.518 0 0 0-.193.644c-.036.24-.058.485-.058.738v.158zM190.31 7.76v.45c0 .26.014.529.035.809.021.281.07.534.152.768.083.23.199.42.352.569.152.15.357.225.616.225.245 0 .444-.066.587-.202a1.38 1.38 0 0 0 .332-.485c.08-.19.126-.38.148-.577a4.31 4.31 0 0 0 .032-.472h1.302c0 .876-.213 1.565-.642 2.061-.432.497-1.023.746-1.772.746a3.47 3.47 0 0 1-.871-.117c-.3-.077-.57-.251-.81-.521-.246-.27-.445-.67-.603-1.2-.159-.53-.236-1.243-.236-2.139 0-.511.03-1.018.097-1.519a4.45 4.45 0 0 1 .37-1.35c.183-.401.44-.725.774-.97.333-.246.768-.369 1.304-.369.476 0 .873.08 1.188.238.317.159.564.388.75.687.183.3.309.664.385 1.092.069.43.108.913.108 1.453v.823h-3.598m-20.973 15.102v.26c0 1.265.496 1.893 1.496 1.893.231 0 .428-.04.6-.127.171-.09.314-.2.428-.34.115-.141.204-.3.264-.477.059-.177.088-.364.088-.557 0-.54-.114-.948-.345-1.222-.23-.277-.55-.478-.959-.613l-.998-.392a4.514 4.514 0 0 1-.856-.477 2.549 2.549 0 0 1-.596-.6 2.433 2.433 0 0 1-.346-.773 4.096 4.096 0 0 1-.108-.984c0-.472.067-.891.206-1.25a2.48 2.48 0 0 1 .576-.912 2.45 2.45 0 0 1 .894-.564 3.289 3.289 0 0 1 1.163-.195c.59 0 1.055.092 1.396.274.34.183.597.411.77.688.178.273.293.567.342.881.052.314.075.606.075.874v.234h-1.458v-.218c0-.473-.096-.84-.294-1.1-.196-.26-.524-.39-.984-.39-.154 0-.306.026-.452.08a1.05 1.05 0 0 0-.399.254 1.249 1.249 0 0 0-.275.463 2.08 2.08 0 0 0-.102.693c0 .443.109.792.322 1.05.211.253.56.487 1.048.7l.983.404c.648.26 1.12.603 1.415 1.028.294.425.441.992.441 1.706 0 .546-.073 1.019-.21 1.409-.143.39-.345.712-.609.968a2.451 2.451 0 0 1-.953.56c-.372.114-.787.17-1.247.17-.565 0-1.024-.096-1.389-.292a2.286 2.286 0 0 1-.85-.742 2.838 2.838 0 0 1-.422-1.011 5.53 5.53 0 0 1-.116-1.109v-.244h1.461m5.42-7.128h1.382v3.384l.037.027c.197-.338.44-.6.724-.786.288-.188.608-.281.965-.281.268 0 .503.034.712.107.207.072.387.19.536.355.147.163.266.38.348.652.078.267.122.6.122.996v5.87h-1.384v-5.335c0-.52-.071-.885-.211-1.092-.14-.207-.39-.31-.75-.31-.28 0-.534.123-.76.367-.225.247-.34.63-.34 1.152v5.217h-1.38V15.734m7.266 6.433c0 .495.013.924.044 1.296.028.371.087.677.173.917.084.243.204.423.358.544.154.12.353.18.601.18.257 0 .461-.06.615-.18.153-.12.272-.3.357-.544a3.9 3.9 0 0 0 .173-.917c.03-.372.043-.8.043-1.296 0-.431-.013-.829-.043-1.183a4.36 4.36 0 0 0-.173-.927 1.44 1.44 0 0 0-.357-.608c-.154-.143-.358-.216-.615-.216a.852.852 0 0 0-.601.216 1.427 1.427 0 0 0-.358.608 3.91 3.91 0 0 0-.173.927c-.03.354-.044.752-.044 1.183zm1.176 4.093c-.479 0-.877-.097-1.201-.297a2.244 2.244 0 0 1-.79-.838 4.267 4.267 0 0 1-.433-1.293 9.516 9.516 0 0 1-.135-1.665c0-.605.042-1.159.12-1.661a4.29 4.29 0 0 1 .41-1.294c.193-.362.454-.64.782-.838.33-.198.743-.296 1.247-.296.495 0 .907.098 1.24.296.335.197.597.476.793.838.198.36.335.792.416 1.294.082.502.122 1.056.122 1.661 0 .608-.044 1.165-.134 1.665a4.23 4.23 0 0 1-.434 1.293 2.212 2.212 0 0 1-.794.838c-.329.2-.73.297-1.209.297m3.081-7.981h1.435l.957 6.132h.027l1.024-6.132h1.56l1.023 6.132h.025l.948-6.132h1.379l-1.572 7.778h-1.548l-1.072-6.043h-.028l-.986 6.043h-1.609l-1.563-7.778M168.21 30.345h1.78l2.646 7.693h.025v-7.693h1.382v10.323h-1.779l-2.645-7.895h-.027v7.895h-1.381V30.345m10.654 5.565v-.419c0-.49-.081-.902-.234-1.234-.162-.334-.436-.5-.826-.5a.886.886 0 0 0-.553.166 1.24 1.24 0 0 0-.352.448 2.402 2.402 0 0 0-.19.645c-.04.24-.058.485-.058.736v.159zm-2.213 1.07v.449c0 .26.01.53.033.81.019.281.071.534.152.767.08.23.198.422.351.57.155.152.357.225.617.225.246 0 .443-.067.587-.2.145-.137.253-.3.33-.489.08-.186.129-.38.15-.577.02-.197.033-.354.033-.472h1.303c0 .882-.216 1.566-.647 2.061-.429.498-1.021.747-1.77.747-.283 0-.574-.038-.871-.117-.3-.075-.567-.248-.81-.518-.245-.27-.445-.672-.602-1.2-.157-.532-.237-1.245-.237-2.141 0-.511.033-1.017.097-1.517.063-.504.187-.953.37-1.355.182-.399.438-.723.774-.967.33-.245.765-.37 1.304-.37.477 0 .873.082 1.188.24.317.16.568.386.75.687.183.298.311.66.383 1.092.074.43.11.914.11 1.452v.824h-3.595m4.26-4.091h1.432l.96 6.13h.023l1.024-6.13h1.561l1.024 6.13h.025l.944-6.13h1.383l-1.572 7.778h-1.55l-1.075-6.043h-.023l-.985 6.043h-1.611l-1.56-7.778m12.2 2.27v-.204c0-.154-.012-.303-.039-.446a1.02 1.02 0 0 0-.145-.386l-.284-.268a.884.884 0 0 0-.44-.1c-.27 0-.503.077-.696.233-.193.153-.287.414-.287.781 0 .309.071.54.208.694.143.155.396.304.762.447l.882.346c.512.194.891.46 1.132.805.244.343.366.822.366 1.439 0 .413-.064.772-.192 1.068a1.99 1.99 0 0 1-.524.737c-.22.193-.483.334-.787.427a3.24 3.24 0 0 1-.967.138c-.436 0-.796-.057-1.085-.167a1.648 1.648 0 0 1-.697-.477 1.796 1.796 0 0 1-.371-.76 4.175 4.175 0 0 1-.11-1.01v-.293h1.229v.248c0 .465.076.81.229 1.043.155.232.436.346.844.346.385 0 .668-.1.852-.304.183-.201.273-.482.273-.839 0-.567-.249-.948-.753-1.143l-1.125-.448c-.523-.194-.898-.457-1.127-.793-.23-.339-.344-.82-.344-1.447 0-.734.212-1.274.633-1.619.422-.347.995-.521 1.72-.521.435 0 .794.064 1.074.197.282.127.501.298.658.505.158.209.266.436.327.686.06.252.09.494.09.738v.347h-1.306m-24.902 9.794h1.78l2.646 7.695h.025v-7.695h1.382v10.324h-1.779l-2.645-7.892h-.027v7.892h-1.381V44.954m10.654 5.57v-.42c0-.494-.081-.905-.234-1.238-.162-.333-.436-.497-.826-.497a.89.89 0 0 0-.553.164c-.143.111-.261.26-.352.45a2.384 2.384 0 0 0-.19.644c-.04.24-.058.484-.058.735v.162zm-2.213 1.067v.449c0 .261.01.53.033.81.019.28.071.535.152.764.08.236.198.424.351.573.155.152.357.225.617.225.246 0 .443-.067.587-.2.145-.138.253-.3.33-.49.08-.184.129-.377.15-.576a5.13 5.13 0 0 0 .033-.47h1.303c0 .878-.216 1.564-.647 2.06-.429.497-1.021.747-1.77.747a3.47 3.47 0 0 1-.871-.117c-.3-.076-.567-.248-.81-.521-.245-.27-.445-.669-.602-1.203-.157-.526-.237-1.24-.237-2.136a12 12 0 0 1 .097-1.52c.063-.5.187-.95.37-1.35.182-.401.438-.723.774-.969.33-.248.765-.37 1.304-.37.477 0 .873.077 1.188.24.317.158.568.386.75.687.183.298.311.66.383 1.092.074.428.11.912.11 1.452v.823h-3.595m4.118-4.091h.946v-2.212h1.383v2.213h1.124v1.154h-1.124V53.3c0 .308.045.52.133.641.09.12.253.183.493.183.202 0 .374-.014.498-.043v1.155c-.299.086-.67.131-1.114.131-.23 0-.432-.026-.606-.074a.842.842 0 0 1-.432-.274c-.118-.136-.206-.325-.266-.573a4.275 4.275 0 0 1-.089-.957v-4.833h-.947v-1.154m3.699-.002h1.432l.959 6.13h.025l1.021-6.13h1.564l1.02 6.13h.028l.947-6.13h1.381l-1.574 7.778h-1.547l-1.075-6.042h-.026l-.984 6.042h-1.612l-1.559-7.777m10.271 3.889c0 .49.012.923.042 1.295.03.371.087.676.174.918.082.24.205.42.357.538.153.122.355.185.601.185.258 0 .462-.063.615-.185.155-.117.273-.298.357-.538a3.62 3.62 0 0 0 .171-.918c.032-.372.045-.805.045-1.295 0-.435-.013-.83-.045-1.186a3.969 3.969 0 0 0-.17-.924 1.406 1.406 0 0 0-.358-.609c-.153-.144-.357-.217-.615-.217a.844.844 0 0 0-.601.217 1.419 1.419 0 0 0-.357.61 3.96 3.96 0 0 0-.174.923c-.03.355-.042.75-.042 1.186zm1.174 4.093c-.476 0-.877-.1-1.204-.299a2.23 2.23 0 0 1-.786-.839 4.244 4.244 0 0 1-.434-1.291 9.83 9.83 0 0 1-.13-1.664c0-.608.04-1.162.118-1.666.079-.5.218-.93.408-1.29.194-.363.454-.643.783-.843.328-.195.744-.294 1.245-.294.496 0 .91.099 1.24.294.334.2.598.48.795.842.195.36.333.791.413 1.291.083.504.122 1.058.122 1.666 0 .607-.042 1.16-.132 1.664-.09.5-.235.93-.434 1.291a2.189 2.189 0 0 1-.794.839c-.328.2-.731.299-1.21.299m3.631-7.983h1.384v1.214h.025c.152-.43.358-.777.623-1.033.257-.256.584-.384.977-.384.159 0 .271.02.332.058v1.59l-.238-.06-.336-.025a1.85 1.85 0 0 0-.48.069 1.06 1.06 0 0 0-.45.27 1.43 1.43 0 0 0-.325.54c-.087.234-.128.527-.128.885v4.654h-1.384V47.5m4.031-2.546h1.382v5.799h.026l2.085-3.252 1.597-.016-2.072 3.009 2.342 4.784h-1.51l-1.689-3.543-.779 1.072v2.47h-1.382V44.955"
            />
          </g>
        </svg>
      );
    case 'ufi':
      return (
        <svg viewBox="0 0 257.333 257.333">
          <g
            stroke="none"
            fillRule="evenodd"
            // transform="scale(2) translate(-60, -100)"
          >
            <path
              vectorEffect="non-scaling-stroke"
              fill="#acb106"
              d="M133.61 57.143v-.003a2.88 2.88 0 0 0-3.341-4.696v-.001l-52.6 37.406v.003a2.885 2.885 0 0 0-.646 3.996 2.879 2.879 0 0 0 3.984.701l52.604-37.406m6.919 9.73a2.887 2.887 0 0 0 .657-4 2.885 2.885 0 0 0-3.995-.7h-.003L98.246 89.87h.002a2.887 2.887 0 0 0-.65 3.999 2.886 2.886 0 0 0 3.99.699v.001l38.943-27.695m6.922 9.733-.002-.003a2.88 2.88 0 0 0 .652-4.003 2.885 2.885 0 0 0-3.991-.697h-.003l-25.288 17.984a2.887 2.887 0 0 0-.645 3.997 2.879 2.879 0 0 0 3.986.7v.004l25.291-17.982"
            />
            <path
              vectorEffect="non-scaling-stroke"
              fill="#acb106"
              d="M158.976 35.53a2.883 2.883 0 0 0-4.7 3.342h-.003l5.271 7.405-2.32 1.651h.003a2.883 2.883 0 0 0-.648 3.996 2.886 2.886 0 0 0 3.989.7v.003l2.317-1.647 1.394 1.959c.01.005.013.008.021.013l-.008.003c4.985 7.061 3.344 16.817-3.673 21.856l-21.164 15.042.005.006a2.883 2.883 0 0 0-.65 3.997 2.895 2.895 0 0 0 3.994.703s21.065-14.978 21.101-15c9.663-6.875 11.934-20.27 5.087-29.948l-10.016-14.084v.002"
            />
            <path
              vectorEffect="non-scaling-stroke"
              fill="#274c75"
              d="M135.564 127.167c0-5.816.677-9.728 2.465-12.3 3.355-4.919 9.276-5.702 13.415-5.702 3.468 0 6.71.667 8.164 1.23.67.222 2.572 1.117 2.572 3.465 0 2.013-1.456 3.69-3.244 3.69-.895 0-4.472-.56-5.257-.56-7.603 0-8.38 4.25-8.38 11.07v4.584h6.034c2.346 0 5.928 0 5.928 3.468 0 3.688-3.802 3.688-5.928 3.688H145.3v44.163c0 3.245-.118 5.37-1.462 6.601-.669.67-1.894 1.339-3.462 1.339-1.226 0-2.571-.447-3.471-1.339-1.34-1.345-1.34-3.356-1.34-6.601V139.8h-5.254c-1.116 0-5.364 0-5.364-3.688 0-3.468 4.248-3.468 5.59-3.468h5.028v-5.477m38.255-5.48c-3.017 0-5.365-2.46-5.365-5.478 0-2.908 2.348-5.369 5.365-5.369 3.02 0 5.368 2.461 5.368 5.37 0 3.017-2.348 5.477-5.368 5.477zm4.921 62.276c0 3.132-.108 4.028-.448 4.81-.672 2.124-2.681 3.13-4.473 3.13-4.807 0-4.92-4.472-4.92-7.94v-44.718c0-3.469.113-5.147 1.343-6.487.896-.897 2.122-1.453 3.689-1.453 2.57 0 3.465 1.002 4.139 2.23.67 1.234.67 3.803.67 5.71v44.718m-71.417-51.31-.03.028c-1.19 1.294-1.247 2.93-1.247 5.492v34.81c0 5.382-4.377 9.762-9.765 9.762-5.33 0-9.71-4.34-9.759-9.676v-34.896c0-1.601 0-3.598-.615-4.728-.58-1.063-1.495-2.149-3.902-2.149-1.347 0-2.526.469-3.415 1.357l-.03.028c-1.183 1.294-1.244 2.93-1.244 5.492l.003 35.043c.125 10.33 8.64 18.733 18.962 18.733 10.31 0 18.828-8.383 18.97-18.69l.003-35.086c0-1.601 0-3.598-.613-4.728-.581-1.063-1.5-2.149-3.908-2.149-1.345 0-2.527.469-3.41 1.357m-30.017 70.372h6.745l4.192 14.435 4.164-14.435h6.884v19.988h-3.97v-16.907l-5.218 16.907h-3.748l-5.218-16.907v16.907h-3.831v-19.988m30.896 20.293c-4.08 0-6.496-2.61-6.496-7.135 0-4.774 2.471-7.44 6.69-7.44 3.942 0 6.218 2.583 6.218 7.246 0 .305 0 .611-.028.916h-8.993c.027 2.499.888 3.72 2.581 3.72 1.333 0 2.11-.639 2.416-1.97h3.58c-.222 2.914-2.415 4.663-5.968 4.663zm2.276-8.994c-.027-2-.804-3.027-2.36-3.027-1.36 0-2.303 1.083-2.414 3.027h4.774m6.413-2.582c0-.86-.028-1.75-.111-2.665h3.83l.111 2.082c1.056-1.694 2.444-2.415 4.498-2.415 2.11 0 3.58.944 4.247 2.72.916-1.887 2.332-2.72 4.553-2.72 3.108 0 4.552 1.75 4.552 5.302v8.967h-4.025v-8.411c0-1.972-.583-2.916-2.276-2.916-1.527 0-2.554 1.055-2.554 2.749v8.578h-4.025v-8.411c0-1.972-.583-2.916-2.249-2.916-1.527 0-2.526 1.055-2.526 2.749v8.578h-4.025v-11.271m24.595 8.966v-17.683h4.025v7.968c.999-1.472 2.36-2.166 4.192-2.166 3.303 0 5.635 2.72 5.635 7.218 0 4.497-2.415 7.245-5.691 7.245-1.776 0-3.192-.776-4.192-2.276l-.139 1.999h-3.969a19.48 19.48 0 0 0 .139-2.305zm6.912-.111c1.749 0 2.832-1.582 2.832-4.525 0-2.942-1.083-4.552-2.832-4.552-1.748 0-2.971 1.665-2.971 4.552 0 2.888 1.223 4.525 2.97 4.525m15.102 2.721c-4.081 0-6.496-2.61-6.496-7.135 0-4.774 2.47-7.44 6.69-7.44 3.942 0 6.218 2.583 6.218 7.246 0 .305 0 .611-.027.916h-8.994c.028 2.499.888 3.72 2.581 3.72 1.332 0 2.11-.639 2.416-1.97h3.58c-.221 2.914-2.415 4.663-5.968 4.663zm2.276-8.994c-.028-2-.805-3.027-2.359-3.027-1.361 0-2.305 1.083-2.414 3.027h4.773m6.357-.916c0-1.583-.056-3.027-.166-4.33h3.72l.138 2.497c.722-1.72 2.276-2.609 4.58-2.609h.112v3.664c-.305-.027-.612-.055-.889-.055-2.137 0-3.387 1.11-3.387 2.915v7.523h-4.108v-9.605"
            />
            <path
              vectorEffect="non-scaling-stroke"
              fill="#274c75"
              d="M77.307 203.025h6.745l4.192 14.435 4.164-14.435h6.884v19.988h-3.97v-16.907l-5.218 16.907h-3.748l-5.218-16.907v16.907h-3.831v-19.988m30.896 20.293c-4.08 0-6.496-2.61-6.496-7.135 0-4.774 2.471-7.44 6.69-7.44 3.942 0 6.218 2.583 6.218 7.246 0 .305 0 .611-.028.916h-8.993c.027 2.499.888 3.72 2.581 3.72 1.333 0 2.11-.639 2.416-1.97h3.58c-.222 2.914-2.415 4.663-5.968 4.663zm2.276-8.994c-.027-2-.804-3.027-2.36-3.027-1.36 0-2.303 1.083-2.414 3.027h4.774m6.413-2.582c0-.86-.028-1.75-.111-2.665h3.83l.111 2.082c1.056-1.694 2.444-2.415 4.498-2.415 2.11 0 3.58.944 4.247 2.72.916-1.887 2.332-2.72 4.553-2.72 3.108 0 4.552 1.75 4.552 5.302v8.967h-4.025v-8.411c0-1.972-.583-2.916-2.276-2.916-1.527 0-2.554 1.055-2.554 2.749v8.578h-4.025v-8.411c0-1.972-.583-2.916-2.249-2.916-1.527 0-2.526 1.055-2.526 2.749v8.578h-4.025v-11.271m24.595 8.966v-17.683h4.025v7.968c.999-1.472 2.36-2.166 4.192-2.166 3.303 0 5.635 2.72 5.635 7.218 0 4.497-2.415 7.245-5.691 7.245-1.776 0-3.192-.776-4.192-2.276l-.139 1.999h-3.969a19.48 19.48 0 0 0 .139-2.305zm6.912-.111c1.749 0 2.832-1.582 2.832-4.525 0-2.942-1.083-4.552-2.832-4.552-1.748 0-2.971 1.665-2.971 4.552 0 2.888 1.223 4.525 2.97 4.525m15.102 2.721c-4.081 0-6.496-2.61-6.496-7.135 0-4.774 2.47-7.44 6.69-7.44 3.942 0 6.218 2.583 6.218 7.246 0 .305 0 .611-.027.916h-8.994c.028 2.499.888 3.72 2.581 3.72 1.332 0 2.11-.639 2.416-1.97h3.58c-.221 2.914-2.415 4.663-5.968 4.663zm2.276-8.994c-.028-2-.805-3.027-2.359-3.027-1.361 0-2.305 1.083-2.414 3.027h4.773m6.357-.916c0-1.583-.056-3.027-.166-4.33h3.72l.138 2.497c.722-1.72 2.276-2.609 4.58-2.609h.112v3.664c-.305-.027-.612-.055-.889-.055-2.137 0-3.387 1.11-3.387 2.915v7.523h-4.108v-9.605"
            />
          </g>
        </svg>
      );
    case 'icca-min':
      return (
        <svg viewBox="0 0 242.52 140.39">
          <path
            fill="#001640"
            d="M27.99 61.37c0 1.33-1.08 2.4-2.42 2.4H16.6c-1.34 0-2.42-1.07-2.42-2.4V17.85c0-1.33 1.08-2.39 2.42-2.39h8.97c1.34 0 2.42 1.07 2.42 2.39v43.52zm176.79-16.39c.68 0 1.23-.53 1.23-1.18 0-.18-.04-.35-.12-.5l-6.52-13.97c-.18-.43-.62-.73-1.13-.73-.51 0-.94.3-1.13.73l-6.52 13.97c-.07.15-.12.32-.12.5 0 .65.56 1.18 1.23 1.18h13.08zm-1.42-29.52c1.19 0 2.23.64 2.76 1.58l21.94 43.71a2 2 0 0 1 .25.97c0 1.13-.96 2.05-2.13 2.05h-8.92c-1.13 0-2.41-.19-3.17-1.6l-2.59-5.69c-.29-.66-.97-1.13-1.77-1.13h-22.99c-.8 0-1.48.47-1.77 1.13l-2.58 5.69c-.75 1.41-2.03 1.6-3.17 1.6h-8.92c-1.17 0-2.13-.92-2.13-2.05a2 2 0 0 1 .25-.97l21.94-43.71c.53-.94 1.57-1.58 2.76-1.58h10.24zM51.95 39.65c0 8.44 6.81 15.57 17.35 15.57 5.7 0 10.1-2.74 12.76-6.88.96-1.64 1.53-2.4 3.71-2.4h9.69c1.79 0 2.57 1.55 2.21 2.9-2.07 8.54-12.22 16.04-28.37 16.27-18.97.27-31.34-11.15-31.34-25.46 0-14.32 12.37-25.74 31.34-25.47 16.15.23 26.3 7.73 28.36 16.28.36 1.35-.43 2.9-2.21 2.9h-9.69c-2.18 0-2.75-.76-3.71-2.4-2.65-4.15-7.05-6.89-12.75-6.89-10.54 0-17.35 7.13-17.35 15.58zm67.34 0c0 8.44 6.81 15.57 17.36 15.57 5.7 0 10.1-2.74 12.76-6.88.95-1.64 1.53-2.4 3.71-2.4h9.68c1.79 0 2.57 1.55 2.21 2.9-2.06 8.54-12.21 16.05-28.36 16.28-18.97.27-31.34-11.15-31.34-25.46 0-14.32 12.37-25.74 31.34-25.47 16.15.23 26.29 7.73 28.36 16.28.36 1.35-.42 2.9-2.21 2.9h-9.68c-2.18 0-2.75-.76-3.71-2.4-2.66-4.15-7.06-6.88-12.76-6.88-10.55-.02-17.36 7.11-17.36 15.56zM49.2 125.49h-5.23V94.68l-10.94 20.96h-3.11L19.06 94.68v30.81h-4.89V89.74h7.14l10.48 19.91 10.15-19.91h7.26v35.75zm13.08-16.35c.21-2.12 1.11-3.88 2.68-5.31 1.58-1.43 3.7-2.14 6.36-2.14 2.64 0 4.61.65 5.9 1.94 1.3 1.3 1.95 3.13 1.97 5.51H62.28zm21.74.99c0-3.88-1.08-6.89-3.24-9-2.16-2.11-5.23-3.16-9.21-3.16-4.3 0-7.77 1.29-10.4 3.86-2.63 2.58-3.95 6.05-3.95 10.43 0 4.42 1.38 7.84 4.13 10.24s6.58 3.6 11.48 3.6c1.92 0 3.76-.22 5.5-.64 1.75-.43 3.46-.97 5.14-1.6v-4.93h-.27c-.86.7-2.31 1.4-4.35 2.13-2.04.73-4.06 1.09-6.07 1.09-1.52 0-2.91-.19-4.17-.58-1.26-.38-2.35-.95-3.27-1.71-.95-.78-1.7-1.79-2.25-3.01s-.82-2.63-.82-4.27h21.74l.01-2.45zm50.53 15.36h-4.95v-15.27c0-1.14-.05-2.25-.17-3.32-.11-1.08-.35-1.93-.72-2.56a3.97 3.97 0 0 0-1.75-1.56c-.76-.35-1.85-.53-3.28-.53-1.4 0-2.79.31-4.19.94-1.39.63-2.79 1.43-4.18 2.42.05.37.09.79.13 1.28.04.48.06.97.06 1.46v17.14h-4.95v-15.27c0-1.18-.05-2.3-.17-3.36-.11-1.07-.36-1.92-.73-2.55-.4-.69-.99-1.2-1.75-1.55-.76-.34-1.86-.51-3.29-.51-1.36 0-2.72.3-4.09.91-1.37.61-2.74 1.38-4.1 2.31v20.02h-4.95v-26.8h4.95v2.98c1.55-1.17 3.1-2.08 4.64-2.73s3.19-.97 4.94-.97c2.01 0 3.72.38 5.12 1.14s2.45 1.82 3.14 3.17c2.01-1.52 3.84-2.62 5.5-3.3s3.43-1.01 5.32-1.01c3.24 0 5.63.89 7.18 2.68 1.54 1.79 2.31 4.27 2.31 7.46v17.38h-.02zm28.1-5.79c-1.57 1.64-3.73 2.45-6.49 2.45-1.29 0-2.45-.11-3.47-.32-1.02-.23-2.23-.62-3.65-1.2v-15.35c1.27-.89 2.65-1.62 4.14-2.18s2.96-.84 4.41-.84c2.6 0 4.49.82 5.65 2.48 1.17 1.65 1.75 4.08 1.75 7.28.01 3.48-.77 6.04-2.34 7.68zm4.43-18.09c-2.03-2.43-4.79-3.64-8.29-3.64-1.96 0-3.73.33-5.3.98-1.57.66-3.06 1.51-4.45 2.54V88.13h-4.95v37.36h4.63l.32-1.28c1.21.62 2.46 1.09 3.71 1.46s2.72.54 4.4.54c1.8 0 3.46-.32 4.96-.96 1.51-.63 2.88-1.57 4.13-2.84 1.18-1.21 2.13-2.72 2.83-4.51s1.04-3.8 1.04-6.04c.01-4.4-1-7.83-3.03-10.25zm13.62 7.53c.21-2.12 1.11-3.88 2.68-5.31 1.58-1.43 3.69-2.14 6.36-2.14 2.64 0 4.61.65 5.9 1.94 1.29 1.3 1.95 3.13 1.96 5.51h-16.9zm21.75.99c0-3.88-1.08-6.89-3.24-9s-5.23-3.16-9.21-3.16c-4.3 0-7.77 1.29-10.4 3.86-2.64 2.58-3.95 6.05-3.95 10.43 0 4.42 1.37 7.84 4.12 10.24 2.76 2.4 6.58 3.6 11.49 3.6 1.92 0 3.75-.22 5.5-.64 1.75-.43 3.46-.97 5.13-1.6v-4.93h-.26c-.87.7-2.32 1.4-4.35 2.13-2.04.73-4.06 1.09-6.07 1.09-1.52 0-2.9-.19-4.17-.58-1.26-.38-2.35-.95-3.26-1.71-.95-.78-1.71-1.79-2.25-3.01s-.82-2.63-.82-4.27h21.74v-2.45zm25.89-6.55h-.26c-.74-.15-1.46-.27-2.16-.34s-1.52-.11-2.47-.11c-1.54 0-3.01.31-4.44.92-1.44.62-2.8 1.42-4.12 2.4v19.03h-4.95v-26.8h4.95v3.96c1.98-1.44 3.71-2.46 5.22-3.06s3.04-.9 4.61-.9c.86 0 1.49.02 1.88.07.38.04.97.12 1.74.22v4.61z"
          />
        </svg>
      );
    case 'icca':
      return (
        <svg viewBox="0 0 377.947 611.56">
          <defs>
            <radialGradient
              id="icca-b"
              cx="0"
              cy="0"
              r=".618"
              fx="0"
              fy="0"
              gradientTransform="scale(4938.14 -4938.14) rotate(66.612 .657 -.29)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#f3faed" />
              <stop offset=".23" stopColor="#f3faed" />
              <stop offset="1" stopColor="#b4e294" />
            </radialGradient>
            <radialGradient
              id="icca-d"
              cx="0"
              cy="0"
              r="1"
              fx="0"
              fy="0"
              gradientTransform="scale(1617.642 -1617.642) rotate(57.189 2.519 -.54)"
              gradientUnits="userSpaceOnUse"
              spreadMethod="pad"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset=".64" stopColor="#59c134" />
              <stop offset=".795" stopColor="#59c134" />
              <stop offset="1" stopColor="#fff" />
            </radialGradient>
            <clipPath id="icca-a" clipPathUnits="userSpaceOnUse">
              <path d="M0 1417.3C0 634.57 634.609 0 1417.42 0c782.7 0 1417.23 634.57 1417.23 1417.3v1752.08c0 782.81-634.53 1417.32-1417.23 1417.32C634.609 4586.7 0 3952.19 0 3169.38V1417.3" />
            </clipPath>
            <clipPath id="icca-c" clipPathUnits="userSpaceOnUse">
              <path d="M2370.35 3169.38c0-526.29-426.68-952.97-952.93-952.97-526.326 0-953.025 426.68-953.025 952.97 0 526.34 426.699 952.96 953.025 952.96 526.25 0 952.93-426.62 952.93-952.96" />
            </clipPath>
          </defs>
          <g
            clipPath="url(#icca-a)"
            transform="matrix(.13333 0 0 -.13333 0 611.56)"
          >
            <path
              fill="url(#icca-b)"
              d="M0 1417.3C0 634.57 634.609 0 1417.42 0c782.7 0 1417.23 634.57 1417.23 1417.3v1752.08c0 782.81-634.53 1417.32-1417.23 1417.32C634.609 4586.7 0 3952.19 0 3169.38V1417.3"
            />
          </g>
          <g
            clipPath="url(#icca-c)"
            transform="matrix(.13333 0 0 -.13333 0 611.56)"
          >
            <path
              fill="url(#icca-d)"
              d="M2370.35 3169.38c0-526.29-426.68-952.97-952.93-952.97-526.326 0-953.025 426.68-953.025 952.97 0 526.34 426.699 952.96 953.025 952.96 526.25 0 952.93-426.62 952.93-952.96"
            />
          </g>
          <path
            fill="#fff"
            d="M94.307 175.41v65.298c0 7.907 28.63 7.907 28.63 0v-65.299c0-7.901-28.63-7.901-28.63 0m53.573.001v65.298c0 7.907 28.63 7.907 28.63 0v-65.299c0-7.901-28.63-7.901-28.63 0m-25.005-27.961c0 7.867-6.39 14.248-14.255 14.248-7.865 0-14.24-6.381-14.24-14.248 0-7.87 6.375-14.248 14.24-14.248 7.864 0 14.255 6.379 14.255 14.248m53.57 0c0 7.867-6.382 14.248-14.25 14.248-7.867 0-14.25-6.381-14.25-14.248 0-7.87 6.383-14.248 14.25-14.248 7.868 0 14.25 6.379 14.25 14.248M74.682 174.393v29.164c0 3.954 14.313 3.954 14.313 0v-29.164c0-3.956-14.313-3.956-14.313 0m53.565 0v29.164c0 3.954 14.318 3.954 14.318 0v-29.164c0-3.956-14.318-3.956-14.318 0m53.581 0v29.164c0 3.954 14.315 3.954 14.315 0v-29.164c0-3.956-14.315-3.956-14.315 0m19.631 1.017v65.298c0 7.907 28.617 7.907 28.617 0v-65.299c0-7.901-28.617-7.901-28.617 0m28.56-27.961c0 7.867-6.388 14.248-14.251 14.248-7.87 0-14.247-6.381-14.247-14.248 0-7.87 6.378-14.248 14.247-14.248 7.863 0 14.25 6.379 14.25 14.248m5.386 26.945v29.164c0 3.954 14.312 3.954 14.312 0v-29.164c0-3.956-14.312-3.956-14.312 0m19.626 1.017v65.298c0 7.907 28.623 7.907 28.623 0v-65.299c0-7.901-28.622-7.901-28.622 0m28.559-27.961c0 7.867-6.385 14.248-14.249 14.248-7.865 0-14.24-6.381-14.24-14.248 0-7.87 6.375-14.248 14.24-14.248 7.864 0 14.25 6.379 14.25 14.248m5.379 26.945v29.164c0 3.954 14.317 3.954 14.317 0v-29.164c0-3.956-14.318-3.956-14.318 0"
          />
          <path
            fill="#231f20"
            d="M68.591 394.581c0 1.768-1.443 3.195-3.229 3.195H53.396c-1.787 0-3.232-1.427-3.232-3.195v-58.029c0-1.768 1.445-3.19 3.232-3.19h11.966c1.786 0 3.23 1.422 3.23 3.19v58.03m235.713-21.852c.908 0 1.64-.706 1.64-1.574 0-.241-.057-.465-.158-.67l-8.694-18.623a1.624 1.624 0 0 0-1.512-.978c-.68 0-1.258.402-1.508.978l-8.696 18.624a1.565 1.565 0 0 0-.158.669c0 .868.742 1.573 1.638 1.573zm-1.896-39.367c1.591 0 2.968.85 3.682 2.106l29.253 58.282a2.7 2.7 0 0 1 .33 1.288c0 1.513-1.273 2.737-2.843 2.737h-11.888c-1.508 0-3.216-.255-4.222-2.137l-3.453-7.582c-.38-.882-1.292-1.508-2.359-1.508h-30.657a2.57 2.57 0 0 0-2.359 1.508l-3.445 7.582c-1.005 1.882-2.703 2.137-4.23 2.137h-11.887c-1.566 0-2.836-1.224-2.836-2.737 0-.466.12-.903.33-1.288l29.254-58.282c.705-1.256 2.09-2.106 3.678-2.106h13.652m-201.878 32.249c0 11.255 9.081 20.76 23.138 20.76 7.604 0 13.464-3.648 17.014-9.176 1.278-2.188 2.036-3.201 4.94-3.201h12.916c2.38 0 3.425 2.068 2.948 3.868-2.75 11.392-16.284 21.394-37.818 21.7-25.291.354-41.784-14.863-41.784-33.951 0-19.096 16.493-34.315 41.784-33.959 21.534.303 35.068 10.311 37.818 21.704.477 1.799-.568 3.864-2.948 3.864h-12.916c-2.904 0-3.662-1.013-4.94-3.197-3.55-5.53-9.41-9.177-17.014-9.177-14.057 0-23.138 9.505-23.138 20.765m89.789 0c0 11.255 9.079 20.76 23.141 20.76 7.599 0 13.46-3.648 17.011-9.176 1.27-2.188 2.033-3.201 4.94-3.201h12.91c2.386 0 3.429 2.068 2.951 3.868-2.752 11.392-16.284 21.394-37.812 21.7-25.297.354-41.792-14.863-41.792-33.951 0-19.096 16.495-34.315 41.792-33.959 21.528.303 35.06 10.311 37.812 21.704.478 1.799-.565 3.864-2.95 3.864h-12.911c-2.907 0-3.67-1.013-4.94-3.197-3.55-5.53-9.412-9.177-17.01-9.177-14.063 0-23.142 9.505-23.142 20.765M96.872 480.076h-6.976v-41.087l-14.583 27.954H71.16l-14.476-27.954v41.087h-6.521v-47.667h9.518l13.972 26.544 13.533-26.544h9.685v47.667m17.431-21.8c.281-2.82 1.474-5.177 3.573-7.076 2.104-1.903 4.93-2.859 8.474-2.859 3.523 0 6.143.867 7.87 2.588 1.729 1.73 2.598 4.178 2.622 7.347zm28.987 1.32c0-5.179-1.442-9.181-4.316-11.997-2.874-2.812-6.97-4.219-12.28-4.219-5.735 0-10.357 1.716-13.868 5.147-3.51 3.434-5.27 8.066-5.27 13.905 0 5.899 1.836 10.459 5.508 13.656 3.666 3.201 8.77 4.8 15.31 4.8 2.564 0 5.007-.3 7.332-.86a60.661 60.661 0 0 0 6.85-2.135v-6.568h-.355c-1.15.93-3.083 1.874-5.804 2.836-2.719.98-5.41 1.456-8.091 1.456-2.021 0-3.875-.248-5.558-.773-1.682-.505-3.127-1.26-4.354-2.279-1.265-1.041-2.27-2.382-2.995-4.008-.731-1.625-1.096-3.513-1.096-5.688h28.987v-3.273m67.378 20.48h-6.599v-20.36c0-1.525-.073-3-.232-4.432-.145-1.435-.472-2.573-.967-3.419-.546-.912-1.32-1.605-2.333-2.076-1.01-.469-2.47-.702-4.377-.702-1.87 0-3.727.413-5.586 1.246-1.857.839-3.716 1.907-5.578 3.227.07.49.122 1.057.172 1.705.049.644.076 1.295.076 1.954v22.857h-6.603v-20.36c0-1.573-.07-3.068-.228-4.481-.152-1.427-.477-2.555-.975-3.402-.538-.916-1.314-1.601-2.33-2.062-1.014-.456-2.474-.684-4.38-.684-1.818 0-3.634.402-5.459 1.213-1.828.807-3.648 1.839-5.461 3.08v26.696h-6.599V444.34h6.599v3.976c2.07-1.564 4.133-2.778 6.19-3.642 2.058-.866 4.254-1.295 6.582-1.295 2.681 0 4.954.505 6.825 1.527 1.872 1.013 3.26 2.421 4.181 4.221 2.675-2.032 5.126-3.5 7.332-4.399 2.208-.901 4.578-1.349 7.091-1.349 4.32 0 7.513 1.19 9.577 3.568 2.055 2.38 3.082 5.693 3.082 9.94v23.188m37.466-7.725c-2.092 2.186-4.972 3.267-8.654 3.267-1.724 0-3.26-.142-4.622-.432-1.354-.302-2.974-.822-4.862-1.597v-20.465a24.857 24.857 0 0 1 5.518-2.912c1.982-.75 3.94-1.124 5.88-1.124 3.467 0 5.982 1.098 7.539 3.301 1.56 2.203 2.333 5.435 2.333 9.7 0 4.66-1.033 8.079-3.132 10.261zm5.911-24.12c-2.708-3.235-6.383-4.85-11.05-4.85-2.62 0-4.97.435-7.062 1.313a28.009 28.009 0 0 0-5.937 3.394v-17.83h-6.602v49.819h6.175l.427-1.706c1.62.82 3.273 1.456 4.945 1.94 1.672.49 3.625.724 5.863.724 2.402 0 4.609-.432 6.612-1.273 2.006-.844 3.84-2.097 5.512-3.782 1.576-1.614 2.836-3.627 3.768-6.012.93-2.391 1.393-5.068 1.393-8.047 0-5.89-1.345-10.461-4.044-13.69m18.159 10.046c.278-2.82 1.474-5.177 3.573-7.076 2.104-1.903 4.921-2.859 8.476-2.859 3.521 0 6.141.867 7.87 2.588 1.725 1.73 2.602 4.178 2.62 7.347zm28.992 1.32c0-5.179-1.443-9.181-4.323-11.997-2.875-2.812-6.968-4.219-12.279-4.219-5.738 0-10.356 1.716-13.864 5.147-3.516 3.434-5.27 8.066-5.27 13.905 0 5.899 1.83 10.459 5.5 13.656 3.674 3.201 8.773 4.8 15.314 4.8 2.563 0 5.003-.3 7.331-.86a59.947 59.947 0 0 0 6.847-2.135v-6.568h-.35c-1.156.93-3.09 1.874-5.804 2.836-2.716.98-5.417 1.456-8.094 1.456-2.02 0-3.872-.248-5.558-.773-1.676-.505-3.126-1.26-4.348-2.279-1.27-1.041-2.276-2.382-3-4.008-.724-1.625-1.094-3.513-1.094-5.688h28.992v-3.273m34.529-8.733h-.35a26.772 26.772 0 0 0-2.88-.448 32.9 32.9 0 0 0-3.294-.144c-2.047 0-4.017.412-5.919 1.232-1.914.822-3.737 1.89-5.497 3.202v25.37h-6.601v-35.734h6.601v5.279c2.637-1.921 4.95-3.284 6.961-4.081a16.432 16.432 0 0 1 6.148-1.198c1.151 0 1.99.031 2.506.091.513.057 1.289.155 2.325.292v6.139"
          />
        </svg>
      );

    case 'ifes':
      return (
        <svg viewBox="0 0 48 48">
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M40.976 23.171a1.233 1.233 0 0 1 1.15.6 1.186 1.186 0 0 1 .166.716 125.91 125.91 0 0 1-.679 3.905 1.346 1.346 0 0 1-1.435 1.18h-7.065a1.181 1.181 0 0 1-1.139-.68 1.2 1.2 0 0 1 .132-1.322 1.226 1.226 0 0 1 1.056-.469h5.74c.527-.01.394.038.506-.411.064-.258.089-.526.144-.788.038-.181.01-.278-.207-.263s-.428 0-.642 0h-4.9a1.217 1.217 0 0 1-1.3-1.23 1.2 1.2 0 0 1 1.243-1.236c1.217-.009 6.034 0 7.225 0"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M12.565 25.644c-.366 0-.367 0-.427.358-.141.842-.287 1.684-.419 2.528a1.3 1.3 0 0 1-.806 1.11 1.211 1.211 0 0 1-1.666-1.161c.027-.57.5-3.174.637-3.909a3 3 0 0 1 .158-.618 1.164 1.164 0 0 1 1.149-.778h7.265a1.232 1.232 0 1 1 .008 2.464c-.99.013-4.924 0-5.9 0"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M5 28.509c.137-.8 1.122-6.371 1.489-8.406a1.242 1.242 0 0 1 1.387-1.088A1.22 1.22 0 0 1 8.919 20.5c-.325 1.908-1.3 7.375-1.452 8.2a1.218 1.218 0 0 1-1.054 1.009 1.219 1.219 0 0 1-1.259-.671A3.146 3.146 0 0 1 5 28.509"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M29.751 23.176a1.219 1.219 0 0 1 1.143 1.708 1.2 1.2 0 0 1-1.171.758c-1.03.006-5.87.009-7.261 0a1.223 1.223 0 0 1-1.276-1.471 1.19 1.19 0 0 1 1.224-1c1.216-.007 6.111-.01 7.341 0"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M30.227 19.231a2.015 2.015 0 0 1 .551.067 1.181 1.181 0 0 1 .867 1.278 1.2 1.2 0 0 1-.989 1.108 2.364 2.364 0 0 1-.439.027H23.36a3.185 3.185 0 0 1-.32-.009 1.21 1.21 0 0 1-1.143-1.258 1.206 1.206 0 0 1 1.193-1.209c.516-.021 5.157-.012 6.787-.005h.35"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M34.546 21.71a1.221 1.221 0 0 1-1.31-1.178 1.228 1.228 0 0 1 1.109-1.293 2.442 2.442 0 0 1 .28-.01h6.977a1.375 1.375 0 0 1 .967.309 1.261 1.261 0 0 1 .363 1.349 1.221 1.221 0 0 1-1.129.82c-.6.019-6.068.014-7.258 0"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M19.139 19.232a1.213 1.213 0 0 1 1.286 1.158 1.212 1.212 0 0 1-1.086 1.306 3.386 3.386 0 0 1-.44.017h-6.7c-.107 0-.214 0-.32-.007a1.221 1.221 0 0 1-1.213-1.274 1.228 1.228 0 0 1 1.251-1.2c.832-.012 6.032-.009 7.222 0"
          />
          <path
            stroke="none"
            style={{ stroke: 'none' }}
            fill="#001640"
            d="M21.744 29.571a1.173 1.173 0 0 1-1.121-.7 1.185 1.185 0 0 1 .133-1.283 1.151 1.151 0 0 1 .97-.477q3.649-.007 7.3 0a1.232 1.232 0 1 1-.022 2.463c-1.2.009-6.042.006-7.258 0"
          />
        </svg>
      );
    /**
     * Social Media
     */
    case 'facebook':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M41 24a17 17 0 1 0-19.656 16.793V28.914h-4.317V24h4.316v-3.745c0-4.261 2.538-6.614 6.421-6.614a26.142 26.142 0 0 1 3.805.332v4.184h-2.142a2.457 2.457 0 0 0-2.77 2.655V24h4.715l-.754 4.914h-3.962v11.879A17 17 0 0 0 41 24"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M30.617 28.914 31.371 24h-4.715v-3.189a2.457 2.457 0 0 1 2.77-2.655h2.144v-4.184a26.143 26.143 0 0 0-3.805-.332c-3.883 0-6.421 2.353-6.421 6.614v3.745h-4.317v4.914h4.316v11.879a17.179 17.179 0 0 0 5.313 0V28.914Z"
          />
        </svg>
      );
    case 'twitter':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M37.519 16.878c.021.3.021.6.021.9 0 9.217-7.017 19.847-19.847 19.847v-.006A19.747 19.747 0 0 1 7 34.495a14.189 14.189 0 0 0 1.66.1 14.007 14.007 0 0 0 8.664-2.995 6.984 6.984 0 0 1-6.517-4.84 6.953 6.953 0 0 0 3.149-.12 6.976 6.976 0 0 1-5.595-6.84v-.086a6.931 6.931 0 0 0 3.166.873 6.984 6.984 0 0 1-2.16-9.314 19.8 19.8 0 0 0 14.377 7.287 6.982 6.982 0 0 1 11.887-6.36 14 14 0 0 0 4.43-1.7 7 7 0 0 1-3.066 3.858A13.873 13.873 0 0 0 41 13.265a14.171 14.171 0 0 1-3.481 3.613"
          />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 48 48">
          <g transform="translate(9 9)" strokeMiterlimit="10">
            <path
              vectorEffect="non-scaling-stroke"
              d="M15 .03c-4.069 0-4.575.017-6.169.09a10.989 10.989 0 0 0-3.634.7 7.338 7.338 0 0 0-2.654 1.723A7.338 7.338 0 0 0 .816 5.194 10.988 10.988 0 0 0 .12 8.83C.047 10.425.031 10.93.031 15s.017 4.575.09 6.172a10.988 10.988 0 0 0 .7 3.634 7.338 7.338 0 0 0 1.727 2.652 7.338 7.338 0 0 0 2.651 1.727 10.989 10.989 0 0 0 3.634.7c1.6.073 2.106.09 6.172.09s4.575-.017 6.172-.09a10.989 10.989 0 0 0 3.634-.7 7.655 7.655 0 0 0 4.378-4.378 10.988 10.988 0 0 0 .7-3.634c.073-1.6.09-2.107.09-6.172s-.017-4.576-.09-6.172a10.988 10.988 0 0 0-.7-3.634 7.34 7.34 0 0 0-1.727-2.652A7.339 7.339 0 0 0 24.81.816a10.989 10.989 0 0 0-3.634-.7C19.576.047 19.066.03 15 .03Z"
            />
            <circle
              vectorEffect="non-scaling-stroke"
              cx="7.687"
              cy="7.687"
              r="7.687"
              transform="rotate(-.145 2900.836 -2878.113)"
            />
            <path
              vectorEffect="non-scaling-stroke"
              fill="#aebdc4"
              d="M24.788 7.008a1.8 1.8 0 1 1-1.8-1.8 1.8 1.8 0 0 1 1.8 1.8"
            />
          </g>
        </svg>
      );
    case 'youtube':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M40.3 15.725a4.26 4.26 0 0 0-3-3C34.642 12 24 12 24 12s-10.643 0-13.3.7a4.348 4.348 0 0 0-3 3.025A44.885 44.885 0 0 0 7 23.9a44.719 44.719 0 0 0 .7 8.178 4.26 4.26 0 0 0 3 3c2.689.728 13.3.728 13.3.728s10.642 0 13.3-.7a4.26 4.26 0 0 0 3-3 44.885 44.885 0 0 0 .7-8.178s.028-5.543-.7-8.203Z"
          />
          <path
            vectorEffect="non-scaling-stroke"
            d="M20.611 18.806V29l8.85-5.1Z"
          />
        </svg>
      );
    case 'linkedin':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M22.2 39.355H9.04a1.969 1.969 0 0 1-1.31-.542 3.122 3.122 0 0 1-.493-.623 1.3 1.3 0 0 1-.175-.493A3.885 3.885 0 0 1 7 36.98q.007-12.9 0-25.8a2.106 2.106 0 0 1 .2-.912 2.2 2.2 0 0 1 1.362-1.193A1.632 1.632 0 0 1 9.045 9q13.16.008 26.319.007a1.98 1.98 0 0 1 1.336.552 2.959 2.959 0 0 1 .474.6 1.554 1.554 0 0 1 .185.489 2.047 2.047 0 0 1 .059.487V37.22a3.039 3.039 0 0 1-.206.882 1.806 1.806 0 0 1-.261.43 2.193 2.193 0 0 1-1.215.771 2.352 2.352 0 0 1-.49.049H22.2m-3.371-11.718v7.076c0 .211 0 .212.2.212h4.264c.059.005.086-.015.083-.078s0-.152 0-.227v-6.45a8.681 8.681 0 0 1 .042-1.371c.046-.284.055-.579.129-.859a2.714 2.714 0 0 1 .251-.718 2.371 2.371 0 0 1 .562-.709 2.346 2.346 0 0 1 1.218-.489 3.313 3.313 0 0 1 1.169.044 2.175 2.175 0 0 1 .717.323 1.99 1.99 0 0 1 .677.994 3.932 3.932 0 0 1 .23 1.3c.008 2.633 0 5.266 0 7.9v.2a.133.133 0 0 0 .132.144 1.215 1.215 0 0 0 .17 0h4.017a1.05 1.05 0 0 0 .17 0 .1.1 0 0 0 .065-.06 2.073 2.073 0 0 0 0-.227c0-2.463.006-4.925 0-7.388a9.377 9.377 0 0 0-.052-1.824c-.034-.171.034-.345-.041-.523a2.5 2.5 0 0 1-.061-.512c-.052-.282-.116-.559-.178-.838a5.909 5.909 0 0 0-.373-1.068 2.6 2.6 0 0 0-.22-.392 4.245 4.245 0 0 0-.405-.569 5.032 5.032 0 0 0-.61-.573 4.54 4.54 0 0 0-1.22-.629 3.842 3.842 0 0 0-.407-.115c-.138-.035-.278-.06-.416-.095a3.675 3.675 0 0 0-.424-.066c-.283-.037-.571-.006-.857-.062a8.365 8.365 0 0 0-1.027.052.066.066 0 0 0-.028 0c-.253.107-.529.13-.79.219a4.914 4.914 0 0 0-1.67.977 4.423 4.423 0 0 0-.88 1.084l-.025.046a.3.3 0 0 1-.03-.066.455.455 0 0 1 0-.085v-1.677c0-.157 0-.158-.17-.158h-4.127c-.056 0-.089.008-.086.074s0 .151 0 .227Zm-2.786.011v-7.189c0-.067-.008-.09-.074-.086s-.114 0-.17 0h-4.035c-.269 0-.269 0-.269.259v14.206c0 .056.008.091.074.086h4.376c.066.005.109-.006.1-.089a1.488 1.488 0 0 1 0-.17Zm-2.306-9.263h.452c.05 0 .1-.045.147-.053a2.594 2.594 0 0 0 1.264-.665 3.014 3.014 0 0 0 .566-.816 1.918 1.918 0 0 0 .213-.733 2.294 2.294 0 0 0-.051-.94 2.568 2.568 0 0 0-.132-.428 3.019 3.019 0 0 0-.82-1.051 3.1 3.1 0 0 0-1.228-.538 3.361 3.361 0 0 0-1.082.058 3.407 3.407 0 0 0-1.081.616 2.733 2.733 0 0 0-.6.858 2 2 0 0 0-.226.93c.006.161 0 .322 0 .483 0 .047-.019.108 0 .14.1.143.07.324.16.476s.133.321.231.472a2.639 2.639 0 0 0 1 .91 2.21 2.21 0 0 0 1.193.283"
          />
        </svg>
      );
    case 'pinterest':
      return (
        <svg viewBox="0 0 48 48">
          <path
            vectorEffect="non-scaling-stroke"
            d="M24 7a17 17 0 0 0-6.825 32.571 14.945 14.945 0 0 1 .3-3.9c.327-1.38 2.188-9.263 2.188-9.263a6.531 6.531 0 0 1-.543-2.69c0-2.519 1.46-4.4 3.279-4.4a2.277 2.277 0 0 1 2.293 2.552c0 1.555-.991 3.88-1.5 6.033a2.631 2.631 0 0 0 2.683 3.274c3.221 0 5.39-4.137 5.39-9.039 0-3.726-2.51-6.515-7.074-6.515a8.05 8.05 0 0 0-8.37 8.141 4.908 4.908 0 0 0 1.117 3.336.824.824 0 0 1 .244.947c-.081.313-.269 1.066-.346 1.365a.586.586 0 0 1-.851.425c-2.376-.974-3.485-3.575-3.485-6.499 0-4.829 4.073-10.62 12.15-10.62 6.491 0 10.762 4.7 10.762 9.738 0 6.669-3.708 11.651-9.173 11.651a4.875 4.875 0 0 1-4.153-2.119s-.987 3.917-1.2 4.673a14.224 14.224 0 0 1-1.703 3.639A17 17 0 1 0 24 7"
          />
        </svg>
      );
    case 'facebook-big':
      return (
        <svg viewBox="0 0 48 48">
          <path
            fill="#001640"
            d="M41 24a17 17 0 1 0-19.656 16.793V28.914h-4.317V24h4.316v-3.745c0-4.261 2.538-6.614 6.421-6.614a26.142 26.142 0 0 1 3.805.332v4.184h-2.142a2.457 2.457 0 0 0-2.77 2.655V24h4.715l-.754 4.914h-3.962v11.879A17 17 0 0 0 41 24"
          />
          <path
            fill="#fff"
            d="M30.617 28.914 31.371 24h-4.715v-3.189a2.457 2.457 0 0 1 2.77-2.655h2.144v-4.184a26.143 26.143 0 0 0-3.805-.332c-3.883 0-6.421 2.353-6.421 6.614v3.745h-4.317v4.914h4.316v11.879a17.179 17.179 0 0 0 5.313 0V28.914Z"
          />
        </svg>
      );
    case 'twitter-big':
      return (
        <svg viewBox="0 0 48 48">
          <defs>
            <clipPath id="twitter-a">
              <path fill="#001640" d="M0 0h34v27.627H0z" />
            </clipPath>
          </defs>
          <g clipPath="url(#twitter-a)" transform="translate(7 10)">
            <path
              fill="#001640"
              d="M30.519 6.878c.021.3.021.6.021.9 0 9.217-7.017 19.847-19.847 19.847v-.006A19.747 19.747 0 0 1 0 24.495a14.189 14.189 0 0 0 1.66.1 14.007 14.007 0 0 0 8.664-2.995 6.984 6.984 0 0 1-6.517-4.84 6.953 6.953 0 0 0 3.149-.12A6.976 6.976 0 0 1 1.361 9.8v-.086a6.931 6.931 0 0 0 3.166.873 6.984 6.984 0 0 1-2.16-9.314A19.8 19.8 0 0 0 16.744 8.56 6.982 6.982 0 0 1 28.631 2.2a14 14 0 0 0 4.43-1.7 7 7 0 0 1-3.066 3.858A13.873 13.873 0 0 0 34 3.265a14.171 14.171 0 0 1-3.481 3.613"
              data-name="Pfad 350"
            />
          </g>
        </svg>
      );
    case 'linkedin-big':
      return (
        <svg viewBox="0 0 48 48">
          <defs>
            <clipPath id="linkedin-a">
              <path fill="#001640" d="M0 0h36v30.594H0z" />
            </clipPath>
          </defs>
          <g
            fill="#001640"
            clipPath="url(#linkedin-a)"
            transform="translate(7 9)"
          >
            <path
              fill="#001640"
              d="M15.2 30.355H2.04a1.969 1.969 0 0 1-1.31-.542 3.122 3.122 0 0 1-.493-.623 1.3 1.3 0 0 1-.175-.493A3.885 3.885 0 0 1 0 27.98q.007-12.9 0-25.8a2.106 2.106 0 0 1 .2-.912A2.2 2.2 0 0 1 1.562.075 1.632 1.632 0 0 1 2.045 0q13.16.008 26.319.007A1.98 1.98 0 0 1 29.7.559a2.959 2.959 0 0 1 .474.6 1.554 1.554 0 0 1 .185.489 2.047 2.047 0 0 1 .059.487V28.22a3.039 3.039 0 0 1-.206.882 1.806 1.806 0 0 1-.261.43 2.193 2.193 0 0 1-1.215.771 2.352 2.352 0 0 1-.49.049H15.2m-3.371-11.718v7.076c0 .211 0 .212.2.212h4.264c.059.005.086-.015.083-.078s0-.152 0-.227v-6.45a8.681 8.681 0 0 1 .042-1.371c.046-.284.055-.579.129-.859a2.714 2.714 0 0 1 .251-.718 2.371 2.371 0 0 1 .562-.709 2.346 2.346 0 0 1 1.218-.489 3.313 3.313 0 0 1 1.169.044 2.175 2.175 0 0 1 .717.323 1.99 1.99 0 0 1 .677.994 3.932 3.932 0 0 1 .23 1.3c.008 2.633 0 5.266 0 7.9v.2a.133.133 0 0 0 .132.144 1.215 1.215 0 0 0 .17 0h4.017a1.05 1.05 0 0 0 .17 0 .1.1 0 0 0 .065-.06 2.073 2.073 0 0 0 0-.227c0-2.463.006-4.925 0-7.388a9.377 9.377 0 0 0-.052-1.824c-.034-.171.034-.345-.041-.523a2.5 2.5 0 0 1-.061-.512c-.052-.282-.116-.559-.178-.838a5.909 5.909 0 0 0-.373-1.068 2.6 2.6 0 0 0-.22-.392 4.245 4.245 0 0 0-.405-.569 5.032 5.032 0 0 0-.61-.573 4.54 4.54 0 0 0-1.22-.629 3.842 3.842 0 0 0-.407-.115c-.138-.035-.278-.06-.416-.095a3.675 3.675 0 0 0-.424-.066c-.283-.037-.571-.006-.857-.062a8.365 8.365 0 0 0-1.027.052.066.066 0 0 0-.028 0c-.253.107-.529.13-.79.219a4.914 4.914 0 0 0-1.67.977 4.423 4.423 0 0 0-.88 1.084l-.025.046a.3.3 0 0 1-.03-.066.455.455 0 0 1 0-.085v-1.677c0-.157 0-.158-.17-.158h-4.127c-.056 0-.089.008-.086.074s0 .151 0 .227Zm-2.786.011v-7.189c0-.067-.008-.09-.074-.086s-.114 0-.17 0H4.764c-.269 0-.269 0-.269.259v14.206c0 .056.008.091.074.086h4.376c.066.005.109-.006.1-.089a1.488 1.488 0 0 1 0-.17ZM6.737 9.382h.452c.05 0 .1-.045.147-.053A2.594 2.594 0 0 0 8.6 8.664a3.014 3.014 0 0 0 .566-.816 1.918 1.918 0 0 0 .213-.733 2.294 2.294 0 0 0-.051-.94 2.568 2.568 0 0 0-.132-.428 3.019 3.019 0 0 0-.82-1.051 3.1 3.1 0 0 0-1.228-.538 3.361 3.361 0 0 0-1.082.058 3.407 3.407 0 0 0-1.081.616 2.733 2.733 0 0 0-.6.858 2 2 0 0 0-.226.93c.006.161 0 .322 0 .483 0 .047-.019.108 0 .14.1.143.07.324.16.476s.133.321.231.472a2.639 2.639 0 0 0 1 .91 2.21 2.21 0 0 0 1.193.283"
            />
            <path d="M33.936 26.501a1.528 1.528 0 0 1 .981.225 1.826 1.826 0 0 1 .591.495 2.137 2.137 0 0 1 .388.75 1.223 1.223 0 0 1 .046.823c-.047.112-.01.244-.058.373a2.6 2.6 0 0 1-.445.754 2.376 2.376 0 0 1-1.123.654.872.872 0 0 1-.364.009c-.163-.016-.337.065-.489-.051-.167.042-.289-.083-.431-.127a1.519 1.519 0 0 1-.4-.256c-.061-.044-.1-.11-.162-.158a1.819 1.819 0 0 1-.538-.885 1.592 1.592 0 0 1-.082-.447 1.19 1.19 0 0 1 .036-.436c.043-.127.054-.279.095-.416a2.193 2.193 0 0 1 .333-.574 1.73 1.73 0 0 1 .73-.569 1.523 1.523 0 0 1 .9-.164m1.829 2.036a1.845 1.845 0 0 0-.523-1.29 1.789 1.789 0 0 0-1.323-.576 1.732 1.732 0 0 0-1.265.509 1.816 1.816 0 0 0-.592 1.235 1.843 1.843 0 0 0 .244 1.064 2 2 0 0 0 .7.672 3.2 3.2 0 0 0 .914.265 3.494 3.494 0 0 0 .911-.274 2.085 2.085 0 0 0 .692-.681 1.554 1.554 0 0 0 .237-.924" />
            <path d="M33.205 28.512v-.965c0-.055.007-.088.073-.087H34.3a.549.549 0 0 1 .443.359.568.568 0 0 1-.353.776 1.04 1.04 0 0 0-.175.057c-.012 0-.026.039-.02.047q.268.415.541.827a.432.432 0 0 0 .06.061.413.413 0 0 1-.1.029c-.222.008-.251.009-.35-.212-.111-.246-.3-.437-.419-.678a.2.2 0 0 0-.137-.072 2.013 2.013 0 0 0-.227 0c-.063 0-.077.026-.077.084 0 .255-.007.511 0 .766.005.115-.04.129-.131.118a.414.414 0 0 0-.085 0c-.067.006-.074-.032-.073-.087v-.71Zm.712-.824h-.278c-.163 0-.155-.017-.15.15.006.2.016.39.024.585h.594a.435.435 0 0 0 .286-.134c.081-.068.056-.151.061-.231v-.113c.014-.12-.043-.167-.151-.222-.141-.072-.277-.006-.388-.038" />
          </g>
        </svg>
      );
    case 'instagram':
    case 'youtube':
      return <svg viewBox="0 0 48 48"></svg>;
    case '':
      return <svg viewBox="0 0 48 48"></svg>;
    case 'placeholder':
    default:
      return (
        <svg viewBox="0 0 24 24">
          <g>
            <circle
              cx="12"
              cy="12"
              r="7"
              vectorEffect="non-scaling-stroke"
            ></circle>
          </g>
        </svg>
      );
  }
};

export default function Icon(props: IconProps) {
  const { name, title, className, options, onClick } = props;
  const key = (name || 'mssing').toLowerCase();
  const classes = clsx(
    styles.icon,
    styles[`icon-${toClass(key)}`],
    'icon',
    `icon-${toClass(key)}`,
    className
  );
  // foreach key check if it is not null or undefined and convert to string
  const dataAttributes: { [key: string]: string } = {};
  options &&
    Object.keys(options).forEach((key) => {
      if (options[key]) {
        dataAttributes[`data-${key}`] = options[key]!.toString();
      }
    });

  return (
    <span
      className={classes}
      title={title}
      onClick={onClick}
      {...dataAttributes}
    >
      {iconSVG(key)}
    </span>
  );
}
